/**
 * kult-b2b-builder.js — Firmenpräsente-Konfigurator mit Budget-Vorschlagslogik.
 * Custom Element <kult-b2b-builder>. Liest Produktkarten (data-b2bb-add) aus
 * den Kategorie-Panels, berechnet einen Budget-Vorschlag (Durchlauf 1:
 * Prioritäten je Kategorie, Kaffee zuerst mit Bestseller-Präferenz; Durchlauf
 * 2: Restbudget auffüllen, max. 2 je Kategorie), verwaltet Slots, Tausch,
 * Zubereitung (Pflicht bei Kaffee), Anlass-Karten (gefiltert nach "Für wen"), Anzahl, Summen und sendet über /cart/add.js. Feuert danach
 * Nach dem Hinzufügen Weiterleitung auf die Warenkorbseite (kein Drawer im B2B, data-cart-url).
 * URL-Zustand: ?fuer=&budget=&modus=&box=&anzahl=&zub=&alkohol=ja&anlass=&versand=&etikett=1&lager=1|eigen&karte=1|eigen&edit=<Gruppe>
 * (etiketten=<n> aus älteren Links mit Staffel wird seit 15.10.2026 ignoriert).
 * Grußkarten-Service (18.10.2026, data-card-*): Karte A6 je Kult-Box, eigene Warenkorb-Position (Variante × Anzahl Präsente,
 * Eigenschaft _kultb2b_card_line). Service des Unternehmens wie der Etikett-Service: nicht in costOf/Budget/„Je Präsent“, nur im
 * Gesamtbetrag. Unteroption „eigene Grußkarten“ (karte=eigen): keine Position, 0 €, nur Hinweis an der Kult-Box-Zeile.
 * Zubereitung (06.10.2026): Pills aus Setting grind_map, Wert = Variantenwert (zub=, item.variants[grind]), Label (data-label)
 * für Warenkorb-Eigenschaft und Zusammenfassung. Fehlt die Variante, bleibt die Standard-Variante der Karte.
 * Alkohol-Schalter (06.10.2026, [data-b2bb-alcohol-pill] nein|ja): „Nein“ blendet Produkte mit Alkohol aus (Karten, leere Tabs),
 * ersetzt Alkohol-Produkte im Präsent durch alkoholfreie ähnlichen Preises (gleiche Kategorie, Budget) oder entfernt sie.
 * „Ja“ blendet sie ein und setzt eines ins Präsent: freier Platz + Budget → hinzufügen, sonst Tausch gegen das preislich
 * nächste Produkt (zuerst Confiserie, dann andere Kategorien außer Kaffee). Statuszeile nennt jede Änderung.
 * Etikett-Service (seit 15.10.2026, eigener Druck): Pauschale je Bestellung (Bearbeitung & Druck) + Preis je Kaffeetüte
 * (data-label-tiers {setup, perBag}); Kaffeetüten = Kaffee-Positionen je Präsent × Anzahl. Service des Unternehmens,
 * zählt nicht zum Präsent-Budget (nicht in costOf/itemsGrossPerPresent/Vorschlag/„Je Präsent“), nur im Gesamtbetrag.
 * Anfrage (15.10.2026, [data-b2bb-anfrage]): klappt das Kontaktformular auch unter dem Limit auf; ab Limit+1 Pflicht.
 * PDF-Übersicht (06.10.2026, [data-b2bb-pdf]): downloadPdf() über assets/kult-pdf.js, Kult-Box-Vorschau mit Logo aus kult-b2b-logo-box.
 * Karten: Klick auf Bild/Titel = Hinzufügen ([data-b2bb-pick]); Produkt im Präsent ([data-b2bb-slot-edit]) öffnet „Produkte anpassen“.
 * Logo-Qualität (06.10.2026): aus "kult:b2b:logo" detail.quality → Eigenschaft 'Logo-Qualität' an den Etikett-Positionen,
 * Zeile in configSummary(); bei „nur Vorschau“ ergänzt die Etikett-Statuszeile den Hinweis auf die Druckdatei per E-Mail.
 * edit: Konfiguration aus dem Warenkorb bearbeiten → Button „Änderung speichern“, alte Zeilen
 * der Gruppe werden vor dem Hinzufügen entfernt (/cart/update.js), Gruppen-ID bleibt.
 */
(function () {
  'use strict';

  var ICON_SWAP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h12l-3-3M20 16H8l3 3"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_WARNING = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l10 18H2L12 3Z"/><path d="M12 10v4M12 17h.01"/></svg>';

  var NUM = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  // Cent-Beträge; Netto-Werte sind exakte Gleitkommawerte und werden auf den nächsthöheren Cent aufgerundet (93,456 → 93,46)
  function money(cents) {
    return NUM.format(Math.ceil(cents - 0.0001) / 100) + ' €';
  }
  function ceilCents(cents) { return Math.ceil(cents - 0.0001); }
  /* Karton-Staffel der Sammellieferung (19.10.2026): n = per·a + Rest; Rest gierig in kleine Kartons (mid Präsente),
     ein einzelnes übriges Präsent als Einzelpaket. mid = 0 (Variante fehlt) → alte Regel: Rest 1 = Einzel, Rest 2+ = großer Karton.
     Identisch in assets/kult-cart.js (shipCartons). */
  function shipCartons(n, per, mid) {
    var u = { single: 0, mid: 0, bulk: Math.floor(n / per) }, rest = n % per;
    if (!(mid > 1)) { if (rest === 1) u.single = 1; else if (rest > 1) u.bulk += 1; return u; }
    // Rest günstigst packen: 1 → Einzel, 2–5 → 5er, 6 → 5er + Einzel (19,39 < 21,42), 7–9 → ein 10er (21,42 < 2 × 11,90)
    if (rest >= mid + 2) { u.bulk += 1; rest = 0; }
    while (rest > 0) { if (rest === 1) { u.single += 1; rest = 0; } else { u.mid += 1; rest -= Math.min(rest, mid); } }
    return u;
  }
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  class KultB2bBuilder extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      this.max = parseInt(this.dataset.max, 10) || 5;
      /* Mindestinhalt (Philip 29.10.2026): ein Präsent hat 3 bis 6 Produkte */
      this.min = Math.min(parseInt(this.dataset.min, 10) || 1, this.max);
      this.limit = parseInt(this.dataset.limit, 10) || 100;
      this.dateMinDays = parseInt(this.dataset.dateMinDays, 10) || 5;
      this.shipBulk = parseInt(this.dataset.shipBulk, 10) || 0;
      this.shipBulkNet = parseFloat(this.dataset.shipBulkNet) || (this.shipBulk / 1.19);
      this.shipBulkVariant = parseInt(this.dataset.shipBulkVariant, 10) || 0;
      this.shipSingle = parseInt(this.dataset.shipSingle, 10) || 0;
      this.shipSingleNet = parseFloat(this.dataset.shipSingleNet) || (this.shipSingle / 1.19);
      this.shipSingleVariant = parseInt(this.dataset.shipSingleVariant, 10) || 0;
      this.shipMid = parseInt(this.dataset.shipMid, 10) || 0;
      this.shipMidNet = parseFloat(this.dataset.shipMidNet) || (this.shipMid / 1.19);
      this.shipMidVariant = parseInt(this.dataset.shipMidVariant, 10) || 0;
      this.shipPerMid = parseInt(this.dataset.shipPerMid, 10) || 5;
      this.shipPerBulk = parseInt(this.dataset.shipPerBulk, 10) || 10;
      this.shipping = 'firma';
      this.fuer = 'kunden';
      this.boxVariant = parseInt(this.dataset.boxVariant, 10);
      this.boxGross = parseInt(this.dataset.boxGross, 10) || 0;
      this.boxNet = parseInt(this.dataset.boxNet, 10) || 0;
      this.boxTitle = this.dataset.boxTitle || '';
      this.addUrl = this.dataset.addUrl;
      this.mode = this.dataset.mode === 'netto' ? 'netto' : 'brutto';

      this.items = [];
      this.manual = false;
      this.swapIndex = null;
      this.qty = 1;
      this.occasion = '';
      this.deliveryDate = '';
      this.note = '';
      this.overBudget = false;
      // Etikett-Service (Produkt „etikett-service“, 15.10.2026): Pauschale je Bestellung (Bearbeitung & Druck, setup) +
      // Preis je Kaffeetüte (perBag), je {id, gross, net}. Ohne Preis je Tüte: „Preis folgt“, Häkchen wählbar, keine Warenkorb-Positionen.
      this.labelAvail = typeof this.dataset.labelTiers === 'string';
      this.setup = null;
      this.perBag = null;
      if (this.labelAvail) {
        var labelPart = (x) => (x && x.id && x.gross > 0 ? { id: parseInt(x.id, 10), gross: parseInt(x.gross, 10) || 0, net: parseFloat(x.net) || 0 } : null);
        try {
          var lt = JSON.parse(this.dataset.labelTiers || '{}') || {};
          this.setup = labelPart(lt.setup);
          this.perBag = labelPart(lt.perBag);
        } catch (err) { this.setup = null; this.perBag = null; }
      }
      this.labelPending = this.dataset.labelPending || 'Preis folgt';
      this.labelOn = false;
      this.labelStock = false;   // „Kein Etikett-Service nötig“
      this.labelReason = 'vorhanden';   // 'vorhanden' (Etiketten aus Lager) | 'eigen' (eigene Gestaltung, Pauschale und Tüten bleiben)
      this.logo = null;
      // Grußkarten-Service (18.10.2026): Variante je Kult-Box {id, gross, net} aus dem Produkt „grusskarten-service“
      var cardId = parseInt(this.dataset.cardVariant, 10) || 0;
      var cardGross = parseInt(this.dataset.cardGross, 10) || 0;
      this.cardVar = cardId && cardGross > 0 ? { id: cardId, gross: cardGross, net: parseFloat(this.dataset.cardNet) || cardGross / 1.19 } : null;
      this.cardAvail = !!this.cardVar;
      this.cardName = this.dataset.cardName || 'Grußkarten-Service';
      this.cardTitle = this.dataset.cardTitle || this.cardName;
      this.cardOn = false;
      this.cardOwn = false;   // „Wir stellen eigene Grußkarten bereit“: keine Position, kostenlos beigelegt

      this.cards =Array.from(this.querySelectorAll('[data-b2bb-add]'));
      this.products = this.cards.map(this.parseCard.bind(this));
      this.tabs = Array.from(this.querySelectorAll('[data-b2bb-tab]'));
      this.boxNet = parseFloat(this.dataset.boxNet) || 0;
      this.panels = Array.from(this.querySelectorAll('[data-b2bb-panel]'));
      this.catOrder = this.tabs.map((t) => t.dataset.b2bbTab);
      var kIdx = this.catOrder.indexOf('kaffee');
      if (kIdx > 0) { this.catOrder.splice(kIdx, 1); this.catOrder.unshift('kaffee'); }

      this.fuerButtons = Array.from(this.parentElement.querySelectorAll('[data-b2bb-fuer]'));
      this.fuerHintEl = this.parentElement.querySelector('[data-b2bb-fuer-hint]');
      this.budgetInput = this.parentElement.querySelector('[data-b2bb-budget]');
      this.modeButtons = Array.from(this.parentElement.querySelectorAll('[data-b2bb-mode]'));
      this.pillButtons = Array.from(this.parentElement.querySelectorAll('[data-b2bb-pill]'));
      this.occasionWrap = this.parentElement.querySelector('[data-b2bb-occasions]');
      this.occasionNote = this.parentElement.querySelector('[data-b2bb-occ-note-el]');
      this.shipButtons = Array.from(this.parentElement.querySelectorAll('[data-b2bb-ship]'));
      this.shipNote = this.parentElement.querySelector('[data-b2bb-ship-note]');
      this.shipLine = this.querySelector('[data-b2bb-shipline]');
      this.occasionCards = Array.from(this.parentElement.querySelectorAll('[data-b2bb-occ]'));
      this.suggestBtn = this.parentElement.querySelector('[data-b2bb-suggest]');

      this.slotsEl = this.querySelector('[data-b2bb-slots]');
      this.statusEl = this.querySelector('[data-b2bb-status]');
      this.minNote = this.querySelector('[data-b2bb-min-note]');
      this.meterWrap = this.querySelector('[data-b2bb-meter]');
      this.meterBar = this.querySelector('[data-b2bb-meter-bar]');
      this.meterText = this.querySelector('[data-b2bb-meter-text-value]');
      this.minHint = this.querySelector('[data-b2bb-min-hint]');
      this.grindWrap = this.querySelector('[data-b2bb-grind]');
      this.grindPills = Array.from(this.querySelectorAll('[data-b2bb-grind-pill]'));
      var activeGrind = this.grindPills.filter((p) => p.classList.contains('is-active'))[0];
      this.grind = activeGrind ? activeGrind.dataset.b2bbGrindPill : '';
      this.grindHint = this.querySelector('[data-b2bb-grind-hint]');
      this.alcoholPills = Array.from(this.querySelectorAll('[data-b2bb-alcohol-pill]'));
      this.alcoholAvail = this.alcoholPills.length > 0;
      this.alcoholOn = false;
      this.qtyInput = this.querySelector('[data-b2bb-qty]');
      this.dateInput = this.querySelector('[data-b2bb-date]');
      this.noteInput = this.querySelector('[data-b2bb-note]');
      this.sumEls = {
        perGross: this.querySelector('[data-b2bb-sum-per-gross]'),
        perNet: this.querySelector('[data-b2bb-sum-per-net]'),
        totalGross: this.querySelector('[data-b2bb-sum-total-gross]'),
        totalNet: this.querySelector('[data-b2bb-sum-total-net]'),
        vat: this.querySelector('[data-b2bb-sum-vat]')
      };
      this.submitBtn = this.querySelector('[data-b2bb-submit]');
      this.contactBlock = this.querySelector('[data-b2bb-contact]');
      this.contactToggle = this.querySelector('[data-b2bb-anfrage]');
      this.contactOpen = false;   // „Anfrage stellen“ unter dem Limit (ab Limit+1 ist das Formular immer offen)
      this.errorEl = this.querySelector('[data-b2bb-error]');
      this.copyStatus = this.querySelector('[data-b2bb-copy-status]');
      this.barEl = this.querySelector('[data-b2bb-bar]');
      this.labelWrap = this.querySelector('[data-b2bb-label]');
      this.labelToggle = this.querySelector('[data-b2bb-label-toggle]');
      this.labelPriceEl = this.querySelector('[data-b2bb-label-price]');
      this.labelStatus = this.querySelector('[data-b2bb-label-status]');
      this.labelTest = this.querySelector('[data-b2bb-label-test]');
      this.labelOptions = this.querySelector('[data-b2bb-label-options]');
      this.labelCalc = this.querySelector('[data-b2bb-label-calc]');
      this.stockToggle = this.querySelector('[data-b2bb-label-stock]');
      this.stockHint = this.querySelector('[data-b2bb-label-stock-hint]');
      this.reasonWrap = this.querySelector('[data-b2bb-label-reasons]');
      this.reasonRadios = Array.prototype.slice.call(this.querySelectorAll('[data-b2bb-label-reason]'));
      // Etikett-Service zählt nicht zum Budget: Umschalten löst keinen neuen Vorschlag aus
      if (this.labelToggle) this.labelToggle.addEventListener('change', () => { this._interacted = true; this.labelOn = this.labelToggle.checked; this.render(); });
      if (this.stockToggle) this.stockToggle.addEventListener('change', () => { this._interacted = true; this.labelStock = this.stockToggle.checked; this.flashError(''); this.render(); });
      this.reasonRadios.forEach((r) => r.addEventListener('change', () => { if (!r.checked) return; this._interacted = true; this.labelReason = r.value === 'eigen' ? 'eigen' : 'vorhanden'; this.flashError(''); this.render(); }));
      // Grußkarten-Service zählt ebenfalls nicht zum Budget: kein neuer Vorschlag beim Umschalten
      this.cardWrap = this.querySelector('[data-b2bb-gcard]');
      this.cardToggle = this.querySelector('[data-b2bb-gcard-toggle]');
      this.cardPriceEl = this.querySelector('[data-b2bb-gcard-price]');
      this.cardOptions = this.querySelector('[data-b2bb-gcard-options]');
      this.cardCalc = this.querySelector('[data-b2bb-gcard-calc]');
      this.cardOwnToggle = this.querySelector('[data-b2bb-gcard-own]');
      this.cardHint = this.querySelector('[data-b2bb-gcard-hint]');
      this.cardBudgetHint = this.querySelector('[data-b2bb-gcard-budget]');
      this.cardOwnHint = this.querySelector('[data-b2bb-gcard-own-hint]');
      if (this.cardToggle) this.cardToggle.addEventListener('change', () => { this._interacted = true; this.cardOn = this.cardToggle.checked; this.render(); });
      if (this.cardOwnToggle) this.cardOwnToggle.addEventListener('change', () => { this._interacted = true; this.cardOwn = this.cardOwnToggle.checked; this.render(); });
      if (this.labelAvail) {
        // Logo aus der Section kult-b2b-logo-box (assets/kult-b2b-logo-upload.js): detail { data (PNG-Data-URL), name, color, scale }
        // Druckqualität (06.10.2026, assets/kult-logo-quality.js): detail.quality (Text oder ''), detail.qualityOk (false = nur Vorschau)
        this.onLogo = (e) => {
          var d = (e && e.detail) || {};
          var quality = String(d.quality || '').slice(0, 120);
          this.logo = d.data ? { data: d.data, name: String(d.name || 'logo.png').slice(0, 120), quality: quality, lowRes: !!quality && (d.qualityOk === false || /^nur Vorschau/.test(quality)) } : null;
          this.updateLabel();
        };
        document.addEventListener('kult:b2b:logo', this.onLogo);
        // CTA der Logo-Section („Etikett-Service im Konfigurator wählen“) schaltet die Option ein
        this.onLabelApply = (e) => { if (!e.target.closest || !e.target.closest('[data-b2b-label-apply]')) return; this._interacted = true; this.labelOn = true; this.render(); };
        document.addEventListener('click', this.onLabelApply);
      }

      // Schritt 1 (Für wen, Budget, Modus, Anlass, Vorschlag) liegt außerhalb des Custom Elements → Klicks auf der Section abfangen
      this._interacted = false;
      var root = this.closest('.kult-b2bb') || this.parentElement || this;
      root.addEventListener('click', (e) => { if (e.target.closest('[data-b2bb-fuer],[data-b2bb-ship],[data-b2bb-occ],[data-b2bb-mode],[data-b2bb-pill],[data-b2bb-suggest],[data-b2bb-tab],[data-b2bb-filter],[data-b2bb-grind-pill],[data-b2bb-alcohol-pill],[data-b2bb-add],[data-b2bb-pick],[data-b2bb-slot-edit],[data-b2bb-pdf],[data-b2bb-swap],[data-b2bb-remove],[data-b2bb-qty-inc],[data-b2bb-qty-dec],[data-b2bb-submit],[data-b2bb-copy],[data-b2bb-anfrage]')) this._interacted = true; this.onClick(e); });
      if (this.budgetInput) this.budgetInput.addEventListener('input', () => { this._interacted = true; this.maybeAutoSuggest(); this.render(); });
      if (this.qtyInput) this.qtyInput.addEventListener('input', () => { this._interacted = true; this.qty = Math.max(1, parseInt(this.qtyInput.value, 10) || 1); this.render(); });
      this.contactConfig = this.querySelector('[data-b2bb-contact-config]');
      this.contactJson = this.querySelector('[data-b2bb-contact-json]');
      if (this.dateInput) { this.dateMin = this.minDeliveryDate(); this.dateInput.min = this.dateMin;
        var mt = this.querySelector('[data-b2bb-date-min-text]'); if (mt) mt.textContent = 'Frühestens am ' + this.formatDate(this.dateMin) + ' (' + this.dateMinDays + ' Werktage ab heute).';
        this.dateInput.addEventListener('input', () => { this._interacted = true; this.deliveryDate = this.dateInput.value; this.checkDate(); this.syncUrl(); });
        this.initDatePicker(); }
      var cform = this.querySelector('.kult-b2bb-box__contact-form');
      /* Versand über die App (assets/kult-b2b-lead.js), nie über den Browser: kein Seitenwechsel, keine weiße Seite */
      if (cform) cform.addEventListener('submit', (e) => {
        e.preventDefault();
        if (this._contactSending) return;
        if (!this.checkDate()) { this.dateInput.focus(); return; }
        var bad = Array.prototype.filter.call(cform.elements, (el) => el.willValidate && el.offsetParent !== null && !el.checkValidity())[0];
        if (bad) { if (typeof bad.reportValidity === 'function') bad.reportValidity(); else bad.focus(); return; }
        this.fillContact();
        var cbtn = cform.querySelector('[data-b2bb-contact-submit]');
        var errs = cform.querySelector('[data-b2bb-contact-errors]');
        var lead = window.KultB2BLead;
        this._contactSending = true;
        if (cbtn) { cbtn.disabled = true; cbtn.setAttribute('aria-busy', 'true'); }
        if (errs) errs.hidden = true;
        (lead && typeof lead.submit === 'function' ? lead.submit(cform) : Promise.resolve({ ok: false, error: '' })).then((result) => {
          this._contactSending = false;
          if (cbtn) { cbtn.disabled = false; cbtn.removeAttribute('aria-busy'); }
          if (result && result.ok) {
            var ok = cform.querySelector('[data-b2bb-contact-success]');
            cform.classList.add('is-sent');
            if (ok) { ok.hidden = false; ok.focus({ preventScroll: true }); ok.scrollIntoView({ block: 'center' }); }
            return;
          }
          if (errs) { errs.textContent = (result && result.error) || 'Ihre Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es gleich noch einmal oder schreiben Sie uns eine E-Mail.'; errs.hidden = false; }
        });
      });
      if (this.noteInput) this.noteInput.addEventListener('input', () => { this.note = this.noteInput.value; });

      var initialFuer = this.fuerButtons.filter((b) => b.getAttribute('aria-checked') === 'true')[0];
      this.filterOccasions(initialFuer ? initialFuer.dataset.b2bbFuer : 'kunden');
      this.restoreFromUrl();
      this.updateTabs();
      this.updateCostNote();
      this.render();
      if (this.labelAvail) document.dispatchEvent(new CustomEvent('kult:b2b:logo-request'));
    }

    disconnectedCallback() {
      if (this.onLogo) document.removeEventListener('kult:b2b:logo', this.onLogo);
      if (this.onLabelApply) document.removeEventListener('click', this.onLabelApply);
    }

    // Werktage (Mo–Fr) ab heute addieren → frühester Wunschliefertermin (YYYY-MM-DD)
    minDeliveryDate() {
      var d = new Date(); d.setHours(12, 0, 0, 0);
      var added = 0;
      while (added < this.dateMinDays) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
      var m = String(d.getMonth() + 1).padStart(2, '0'), day = String(d.getDate()).padStart(2, '0');
      return d.getFullYear() + '-' + m + '-' + day;
    }

    // Feld bleibt leer; beim Öffnen springt der Kalender auf den ersten verfügbaren Tag.
    // Dazu wird der Wert nur für die Dauer des Pickers gesetzt und ohne Auswahl wieder geleert.
    initDatePicker() {
      var input = this.dateInput;
      var open = (e) => {
        if (input.value || typeof input.showPicker !== 'function') return;
        e.preventDefault();
        input.value = this.dateMin;
        this._datePreset = true;
        try { input.showPicker(); } catch (err) { input.value = ''; this._datePreset = false; }
      };
      input.addEventListener('pointerdown', open);
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') open(e); });
      var settle = () => { if (this._datePreset) { this._datePreset = false; input.value = ''; this.deliveryDate = ''; } };
      input.addEventListener('change', () => { this._datePreset = false; this.deliveryDate = input.value; });
      input.addEventListener('cancel', settle);
      input.addEventListener('blur', settle);
    }

    formatDate(iso) { var p = iso.split('-'); return p.length === 3 ? p[2] + '.' + p[1] + '.' + p[0] : iso; }

    checkDate() {
      this.dateTooEarly = !!(this.deliveryDate && this.dateMin && this.deliveryDate < this.dateMin);
      if (this.dateTooEarly) this.flashError('Frühester Wunschliefertermin: ' + this.formatDate(this.dateMin) + '. Wenn es schneller gehen soll, nehmen Sie bitte direkt Kontakt mit uns auf.');
      else if (this.errorEl && !this.errorEl.hidden) this.flashError('');
      return !this.dateTooEarly;
    }

    parseCard(btn) {
      var variants = null;
      try { variants = btn.dataset.variants ? JSON.parse(btn.dataset.variants) : null; } catch (err) { variants = null; }
      if (variants && !Object.keys(variants).length) variants = null;
      return {
        handle: btn.dataset.handle,
        title: btn.dataset.title,
        type: btn.dataset.type,
        catKey: btn.dataset.catKey,
        vendor: btn.dataset.vendor || '',
        ort: btn.dataset.ort || '',
        unit: btn.dataset.unit || '',
        url: btn.dataset.url || '',
        gross: parseInt(btn.dataset.gross, 10) || 0,
        net: Math.ceil(parseFloat(btn.dataset.net) || 0), // auf volle Cent aufgerundet wie auf der Karte (Cowork-Test 06.10.2026, Abw. 18)
        netExact: parseFloat(btn.dataset.net) || 0, // exakt, für „Je Präsent netto“ wie im Warenkorb (Testlauf 10.10.2026)
        suggest: btn.dataset.suggest !== 'false',
        tax: isNaN(parseInt(btn.dataset.tax, 10)) ? 7 : parseInt(btn.dataset.tax, 10),
        variant: parseInt(btn.dataset.variant, 10),
        variants: variants,
        img: btn.dataset.img || '',
        bestseller: btn.dataset.bestseller === 'true',
        alcohol: btn.dataset.alkohol === 'mit'
      };
    }

    onClick(e) {
      var t = e.target;
      var el;
      if ((el = t.closest('[data-b2bb-info]'))) return this.toggleInfo(el);
      if ((el = t.closest('[data-b2bb-fuer]'))) return this.selectFuer(el);
      if ((el = t.closest('[data-b2bb-ship]'))) return this.selectShipping(el);
      if ((el = t.closest('[data-b2bb-occ]'))) return this.selectOccasion(el);
      if ((el = t.closest('[data-b2bb-mode]'))) { this.setMode(el.dataset.b2bbMode); this.maybeAutoSuggest(); this.render(); return; }
      if ((el = t.closest('[data-b2bb-pill]'))) { this.budgetInput.value = el.dataset.b2bbPill; this.maybeAutoSuggest(); this.render(); return; }
      if ((el = t.closest('[data-b2bb-suggest]'))) return this.onSuggest();
      if ((el = t.closest('[data-b2bb-tab]'))) return this.showTab(el.dataset.b2bbTab);
      if ((el = t.closest('[data-b2bb-filter]'))) return this.setFilter(el);
      if ((el = t.closest('[data-b2bb-grind-pill]'))) return this.selectGrind(el);
      if ((el = t.closest('[data-b2bb-alcohol-pill]'))) return this.setAlcohol(el.dataset.b2bbAlcoholPill === 'ja', true);
      if ((el = t.closest('[data-b2bb-add]'))) { if (!el.disabled) this.addProductByIndex(this.cards.indexOf(el)); return; }
      // Klick auf Bild oder Titel einer Karte = „Hinzufügen“ (keine Produktseiten-Links mehr, die Konfiguration bleibt erhalten)
      if ((el = t.closest('[data-b2bb-pick]'))) { var pc = el.closest('[data-b2bb-card]'), pb = pc && pc.querySelector('[data-b2bb-add]'); if (pb && !pb.disabled) this.addProductByIndex(this.cards.indexOf(pb)); return; }
      if ((el = t.closest('[data-b2bb-slot-edit]'))) return this.editSlot(parseInt(el.dataset.b2bbSlotEdit, 10));
      if ((el = t.closest('[data-b2bb-pdf]'))) return this.downloadPdf();
      if ((el = t.closest('[data-b2bb-swap]'))) return this.beginSwap(parseInt(el.dataset.b2bbSwap, 10));
      if ((el = t.closest('[data-b2bb-remove]'))) return this.removeSlot(parseInt(el.dataset.b2bbRemove, 10));
      if ((el = t.closest('[data-b2bb-qty-inc]'))) { this.qty += 1; this.qtyInput.value = this.qty; this.render(); return; }
      if ((el = t.closest('[data-b2bb-qty-dec]'))) { this.qty = Math.max(1, this.qty - 1); this.qtyInput.value = this.qty; this.render(); return; }
      if ((el = t.closest('[data-b2bb-submit]'))) return this.submit();
      if ((el = t.closest('[data-b2bb-copy]'))) return this.copyLink();
      if ((el = t.closest('[data-b2bb-anfrage]'))) return this.toggleContact();
      if ((el = t.closest('[data-b2bb-edit]'))) { this.setView('edit'); return; }
      if ((el = t.closest('[data-b2bb-overview]'))) { this.setView('overview'); return; }
    }

    // Fragezeichen: Hinweistext auf-/zuklappen
    toggleInfo(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Versand: firma (Sammellieferung), einzeln (je Adresse), abholung. Bei Mitarbeitenden + einzeln zählt der Versand zum Sachbezug (BFH VI R 32/16)
    selectShipping(btn) {
      this.shipping = btn.dataset.b2bbShip;
      this.shipButtons.forEach((b) => { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
      this.updateShipNote();
      this.maybeAutoSuggest();
      this.render();
    }

    shipCountsInBudget() { return this.fuer === 'mitarbeiter' && this.shipping === 'einzeln'; }
    shipInBudget() { return this.shipCountsInBudget() ? this.priceOf({ gross: this.shipSingle, net: this.shipSingleNet }) : 0; }
    // Versandpositionen. Einzelversand: eine Einzelposition je Präsent (Adresse).
    // Sammellieferung an eine Adresse (Karton-Staffel 19.10.2026, Kult-Box ca. 1,9 kg): je volle 10 Präsente ein 10er-Karton;
    // Rest gierig: 1 → Einzelpaket, 2–5 → 5er-Karton, 6–9 → 5er-Karton + Rest (1 → Einzel, 2–4 → weiterer 5er). Preise aus dem Versandprodukt.
    // Beispiele: 1 → Einzel; 3 → 5er; 12 → 10er + 5er; 16 → 10er + 5er + Einzel. Gleiche Zerlegung in assets/kult-cart.js (Anzahl im Warenkorb).
    // Kasse: bei genau 1 Präsent unter 49 € keine Versandposition; die Function kult-b2b-versandarten zeigt dann
    // „Firmenversand DHL“ nach Gewicht (ab kult_b2b_ship_from, netto 6,50 € bis 1 kg zzgl. MwSt., DHL-Staffel + 1 € seit 13.10.2026; Kasse brutto 6,96 €), die Zusammenfassung sagt „ab … € (in der Kasse)“ (Testlauf 10.10.2026);
    // ab 49 € oder ab 2 Präsenten liegt der Warenkorb immer über 49 €, die Kasse rechnet 0 € und die Positionen gelten.
    // Etikett-Service liegt als eigene Position im Warenkorb und zählt für die 49-€-Schwelle der Kasse mit (nicht fürs Budget)
    itemsGrossPerPresent() { return this.boxGross + this.items.reduce((s, p) => s + p.gross, 0); }
    /* Netto je Präsent wie snippets/kult-cart-b2b-summary.liquid: exakte Summe, einmal auf Cent aufgerundet (Testlauf 10.10.2026: 28,80 vs. 28,79) */
    perNetShown() { return ceilCents(this.boxNet + this.items.reduce((s, p) => s + (p.netExact || p.net), 0)); }
    checkoutChargesShipping() { return this.shipping !== 'abholung' && this.qty === 1 && this.itemsGrossPerPresent() + this.labelTotal() + this.cardTotal() < 4900; }
    shipUnits() {
      if (this.shipping === 'abholung' || this.checkoutChargesShipping()) return { single: 0, mid: 0, bulk: 0 };
      if (this.shipping === 'einzeln') return { single: this.qty, mid: 0, bulk: 0 };
      return shipCartons(this.qty, this.shipPerBulk, this.shipMidVariant ? this.shipPerMid : 0);
    }
    shipTotalGross() { var u = this.shipUnits(); return u.single * this.shipSingle + u.mid * this.shipMid + u.bulk * this.shipBulk; }
    shipTotalNet() { var u = this.shipUnits(); return u.single * this.shipSingleNet + u.mid * this.shipMidNet + u.bulk * this.shipBulkNet; }
    shipRowLabel() {
      var u = this.shipUnits();
      if (!u.single && !u.mid && !u.bulk) return '';
      if (this.shipping === 'einzeln') return 'Versand, ' + u.single + (u.single === 1 ? ' Adresse' : ' Adressen') + ' × ' + money(this.shipSingle);
      var parts = [];
      if (u.bulk) parts.push(u.bulk + ' × ' + this.shipPerBulk + 'er-Karton ' + money(this.shipBulk));
      if (u.mid) parts.push(u.mid + ' × ' + this.shipPerMid + 'er-Karton ' + money(this.shipMid));
      if (u.single) parts.push(u.single + ' × Einzelpaket ' + money(this.shipSingle));
      return 'Versand Sammellieferung, ' + parts.join(' + ');
    }
    /* Warenkorb-Attribut „Einzelversand“ (erscheint in der Bestellung unter „Zusätzliche Details“, Philip 06.10.2026):
       Summe der Präsente aller Konfigurationen mit Versand an unterschiedliche Adressen; keine → Attribut leer. */
    syncShipAttribute(cart) {
      var n = 0;
      (cart.items || []).forEach((it) => { var p = it.properties || {}; if (p._kultb2b_box && p._kultb2b_ship === 'einzeln') n += it.quantity; });
      // ohne Zahl: die Anzahl ergibt sich aus der Menge der Präsente im Warenkorb (Cowork-Test 06.10.2026, Abw. 5)
      var value = n > 0 ? 'Ja – Einzelversand an unterschiedliche Empfängeradressen, eine je Präsent (Anzahl = Menge der Präsente). Adressvorlage (CSV) kommt nach der Bestellung per E-Mail, nicht an die Checkout-Adresse liefern.' : '';
      if ((cart.attributes || {})['Einzelversand'] === value || (!value && !(cart.attributes || {})['Einzelversand'])) return cart;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Einzelversand': value } }) })
        .then((r) => r.json()).catch(() => cart);
    }

    shippingLabel() { var b = this.shipButtons.filter((x) => x.dataset.b2bbShip === this.shipping)[0]; return b ? b.dataset.b2bbShipLabel : ''; }

    updateShipNote() {
      var sn = this.parentElement.querySelector('[data-b2bb-ship-single-note]');
      if (sn) sn.hidden = this.shipping !== 'einzeln';
      if (!this.shipNote) return;
      var counts = this.shipCountsInBudget();
      this.shipNote.hidden = !counts;
      this.shipNote.textContent = counts ? 'Einzelversand an Mitarbeitende: Die Versandkosten je Adresse zählen zum Sachbezug und werden ins Budget eingerechnet.' : '';
      this.updateCostNote();
    }

    // Kosten-Hinweis unter den Summen, je nach Versand-Auswahl
    updateCostNote() {
      var el = this.querySelector('[data-b2bb-cost-note]');
      if (!el) return;
      var ship = this.shipping === 'abholung' ? (el.dataset.pickup || '') : (el.dataset.ship || '').replace('{versand}', this.shippingLabel());
      el.textContent = [el.dataset.intro, ship, el.dataset.invoice].filter(Boolean).join(' ');
      // Lieferzeiten-Text je Versandart (Usertest 06.10.2026, Befund 6)
      var lead = this.querySelector('[data-b2bb-lead-text]');
      if (lead) lead.textContent = (this.shipping === 'abholung' ? lead.dataset.pickup : this.shipping === 'einzeln' ? lead.dataset.single : lead.dataset.ship) || lead.dataset.ship || '';
    }

    selectFuer(btn) {
      this.fuer = btn.dataset.b2bbFuer;
      this.updateShipNote();
      this.fuerButtons.forEach((b) => {
        var on = b === btn;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
      });
      this.budgetInput.value = btn.dataset.b2bbFuerBudget;
      this.setMode(btn.dataset.b2bbModus);
      if (this.fuerHintEl) this.fuerHintEl.textContent = btn.dataset.b2bbHint || '';
      if (this.occasionNote) { this.occasionNote.textContent = btn.dataset.b2bbOccNote || ''; this.occasionNote.hidden = !btn.dataset.b2bbOccNote; }
      this.filterOccasions(btn.dataset.b2bbFuer);
      this.maybeAutoSuggest();
      this.render();
    }

    // Anlass-Karten nach "Für wen" filtern; bei "Ohne steuerliche Vorgabe" ganz ausblenden
    filterOccasions(fuer) {
      if (!this.occasionWrap) return;
      this.occasionWrap.hidden = fuer === 'frei';
      var stillVisible = false;
      this.occasionCards.forEach((card) => {
        var li = card.closest('[data-b2bb-occ-fuer]');
        var show = !li || li.dataset.b2bbOccFuer === fuer;
        if (li) li.hidden = !show;
        if (show && card.getAttribute('aria-pressed') === 'true') stillVisible = true;
      });
      if (fuer === 'frei' || !stillVisible) this.setOccasion(null);
    }

    setOccasion(card) {
      this.occasion = card ? card.dataset.b2bbOcc : '';
      this.occasionCards.forEach((c) => c.setAttribute('aria-pressed', c === card ? 'true' : 'false'));
    }

    selectOccasion(card) {
      if (card.getAttribute('aria-pressed') === 'true') { this.setOccasion(null); this.syncUrl(); return; }
      this.setOccasion(card);
      if (card.dataset.b2bbOccBudget) this.budgetInput.value = card.dataset.b2bbOccBudget;
      if (card.dataset.b2bbOccModus) this.setMode(card.dataset.b2bbOccModus);
      this.maybeAutoSuggest();
      this.render();
    }

    setMode(mode) {
      this.mode = mode === 'netto' ? 'netto' : 'brutto';
      this.dataset.mode = this.mode;
      this.modeButtons.forEach((b) => {
        var on = b.dataset.b2bbMode === this.mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    priceOf(p) { return this.mode === 'netto' ? p.net : p.gross; }
    // Etikett-Service: Kaffee = Produkt mit Zubereitungs-Varianten. Pauschale einmal je Bestellung, dazu je Kaffeetüte ein Etikett
    // (eigenes Etikett mit Sortennamen). Service des Unternehmens: NICHT in costOf/Budget/„Je Präsent“, nur im Gesamtbetrag.
    isCoffee(p) { return !!(p && p.variants); }
    coffeeCount() { return this.items.filter((it) => this.isCoffee(it)).length; }
    labelSorts() { var seen = {}; return this.items.filter((it) => { if (!this.isCoffee(it) || seen[it.handle]) return false; seen[it.handle] = true; return true; }); }
    labelCount() { return this.labelAvail && this.labelOn ? this.labelSorts().length : 0; }
    costOf(p) { return this.priceOf(p); }
    // Kaffeetüten der Bestellung: jede Kaffee-Position liegt einmal je Präsent (auch doppelt gewählte Sorten zählen je Tüte)
    labelBags() { return this.labelCount() ? this.coffeeCount() * this.qty : 0; }
    // Kein Etikett-Service: Etiketten sind bereits vorhanden (Folgeauftrag) → 0 €
    labelSkip() { return this.labelStock && this.labelReason !== 'eigen'; }
    // Eigene Gestaltung: Pauschale (Bearbeitung & Druck) und Tüten bleiben, nur die Druckdatei kommt per E-Mail
    labelOwn() { return this.labelStock && this.labelReason === 'eigen'; }
    // Preis vorhanden = Preis je Kaffeetüte im Produkt (Pauschale optional)
    labelPriced() { return !!this.perBag; }
    labelCharged() { return this.labelCount() > 0 && !this.labelSkip() && this.labelPriced(); }
    printGross() { return this.labelCharged() ? this.perBag.gross * this.labelBags() : 0; }
    printNet() { return this.labelCharged() ? this.perBag.net * this.labelBags() : 0; }
    serviceGross() { return this.labelCharged() && this.setup ? this.setup.gross : 0; }
    serviceNet() { return this.labelCharged() && this.setup ? this.setup.net : 0; }
    labelTotal() { return this.printGross() + this.serviceGross(); }
    labelTotalNet() { return this.printNet() + this.serviceNet(); }
    sortsText(k) { return k + (k === 1 ? ' Sorte' : ' Sorten'); }
    bagsText(n) { return n + (n === 1 ? ' Kaffeetüte' : ' Kaffeetüten'); }
    // Erklärzeile „29,00 € einmalig (Bearbeitung & Druck) + n Kaffeetüten × 0,40 €“ im gewählten Modus (oder explizit brutto/netto)
    labelExplain(mode) {
      if (!this.labelPriced()) return '';
      var pick = (x) => (mode === 'netto' ? x.net : mode === 'brutto' ? x.gross : this.priceOf(x));
      return (this.setup ? money(pick(this.setup)) + ' einmalig (Bearbeitung & Druck) + ' : '') + this.bagsText(this.labelBags()) + ' × ' + money(pick(this.perBag));
    }
    updateLabel() {
      if (!this.labelWrap) return;
      var n = this.coffeeCount();
      this.labelWrap.hidden = n === 0;
      if (this.labelToggle) this.labelToggle.checked = this.labelOn;
      if (this.stockToggle) this.stockToggle.checked = this.labelStock;
      if (this.reasonWrap) this.reasonWrap.hidden = !this.labelStock;
      this.reasonRadios.forEach((r) => { r.checked = r.value === this.labelReason; });
      var priced = this.labelPriced();
      // Kopf-Preiszeile (19.10.2026): „29,00 € einmalig + 0,40 € je Kaffeetüte (netto)“ – einmalig = einmal je Bestellung
      if (this.labelPriceEl) this.labelPriceEl.textContent = priced ? (this.setup ? money(this.priceOf(this.setup)) + ' einmalig + ' : '') + money(this.priceOf(this.perBag)) + ' je Kaffeetüte (' + this.mode + ')' : this.labelPending;
      if (this.labelOptions) this.labelOptions.hidden = !(this.labelOn && n > 0);
      if (this.labelCalc) {
        var charged = this.labelCharged();
        this.labelCalc.hidden = !charged;
        // Kurz (19.10.2026): „Ihr Etikett-Service: 29,00 € einmalig + 30 Tüten × 0,40 € = 41,00 € netto.“ (Rechnung unverändert)
        var bags = this.labelBags();
        this.labelCalc.textContent = charged ? 'Ihr Etikett-Service: ' + (this.setup ? money(this.priceOf(this.setup)) + ' einmalig + ' : '') + bags + (bags === 1 ? ' Tüte' : ' Tüten') + '\u00A0×\u00A0' + money(this.priceOf(this.perBag)) + ' = ' + money(this.priceOf({ gross: this.labelTotal(), net: this.labelTotalNet() })) + ' ' + this.mode + '.' : '';
      }
      if (this.stockHint) {
        this.stockHint.hidden = !(this.labelOn && this.labelStock);
        this.stockHint.textContent = this.labelOwn()
          ? 'Ihre Druckdatei senden Sie uns nach der Bestellung an ' + (this.dataset.labelMail || 'uns') + '; ein Logo-Upload ist optional.'
          : 'Wir prüfen Ihren Etikettenbestand und melden uns, falls Etiketten fehlen.';
      }
      if (this.labelStatus) {
        var needLogo = this.labelOn && !this.labelStock;
        this.labelStatus.hidden = this.labelOn && this.labelStock && (this.labelSkip() || !this.logo);
        this.labelStatus.textContent = this.logo ? 'Ihr Logo „' + this.logo.name + '“ ist hinterlegt.' + (this.logo.lowRes && !this.labelOwn() ? ' Druckdatei bitte nach der Bestellung per E-Mail' + (this.dataset.labelMail ? ' an ' + this.dataset.labelMail : '') + '.' : '') : (needLogo ? 'Bitte laden Sie Ihr Logo hoch, bevor Sie bestellen.' : 'Noch kein Logo hochgeladen.');
        this.labelStatus.classList.toggle('is-missing', needLogo && !this.logo);
      }
    }
    // Grußkarten-Service (18.10.2026): eine Karte je Kult-Box (= Anzahl Präsente). Service des Unternehmens wie der Etikett-Service:
    // NICHT in costOf/Budget/„Je Präsent“, nur im Gesamtbetrag. Eigene Grußkarten: kostenlos beigelegt, keine Position.
    cardActive() { return this.cardAvail && this.cardOn; }
    cardOwnActive() { return this.cardActive() && this.cardOwn; }
    cardCharged() { return this.cardActive() && !this.cardOwn; }
    cardTotal() { return this.cardCharged() ? this.cardVar.gross * this.qty : 0; }
    cardTotalNet() { return this.cardCharged() ? this.cardVar.net * this.qty : 0; }
    boxesText(n) { return n + (n === 1 ? ' Kult-Box' : ' Kult-Boxen'); }
    // Erklärzeile „n Kult-Boxen × 4,50 €“ — immer brutto: netto je Karte ist gerundet (3,79), die Multiplikation
    // ginge dann nicht auf (UX-Review 18.10.2026, Blocker 1). Geschützte Leerzeichen gegen Umbrüche auf Mobil.
    cardExplain() {
      if (!this.cardVar) return '';
      return this.boxesText(this.qty) + '\u00A0×\u00A0' + money(this.cardVar.gross);
    }
    cardOwnText() { return 'Ihre eigenen Grußkarten legen wir kostenlos bei'; }
    updateCard() {
      if (!this.cardWrap) return;
      if (this.cardToggle) this.cardToggle.checked = this.cardOn;
      if (this.cardOwnToggle) this.cardOwnToggle.checked = this.cardOwn;
      if (this.cardPriceEl && this.cardVar) this.cardPriceEl.textContent = this.cardOwnActive() ? 'kostenlos (eigene Karten)' : '+ ' + money(this.priceOf(this.cardVar)) + ' je Kult-Box (' + this.mode + ')';
      // Unteroption nur sichtbar und anwählbar, solange der Service angewählt ist
      if (this.cardOptions) this.cardOptions.hidden = !this.cardActive();
      if (this.cardOwnToggle) this.cardOwnToggle.disabled = !this.cardActive();
      if (this.cardHint) this.cardHint.hidden = !this.cardCharged();
      if (this.cardBudgetHint) this.cardBudgetHint.hidden = this.cardOwnActive();
      if (this.cardOwnHint) this.cardOwnHint.hidden = !this.cardOwnActive();
      if (this.cardCalc) {
        this.cardCalc.hidden = !this.cardActive();
        // Netto-Modus ohne Stückpreis-Multiplikation: 5 × 3,79 (gerundet) ergäbe nicht die exakte Netto-Summe
        this.cardCalc.textContent = this.cardOwnActive() ? this.cardOwnText() + ' (0,00 €).'
          : !this.cardCharged() ? ''
            : this.mode === 'netto' ? 'Ihr ' + this.cardName + ': ' + this.boxesText(this.qty) + ' = ' + money(this.cardTotalNet()) + ' netto (' + money(this.cardTotal()) + ' brutto).'
              : 'Ihr ' + this.cardName + ': ' + this.cardExplain() + ' = ' + money(this.cardTotal()) + ' brutto.';
      }
    }
    // Namen der berechneten Services für „Präsente gesamt (ohne …)“
    serviceNames(labelGross, cardGross) {
      var n = [];
      if (labelGross) n.push('Etikett-Service');
      if (cardGross) n.push(this.cardName);
      return n.join(' und ');
    }
    // Logo vor dem Warenkorb an die Rösterei senden (App-Proxy,Mail an die Shop-Adresse; Referenz = Gruppen-ID der Bestellpositionen)
    sendLogo(group) {
      var endpoint = this.dataset.labelEndpoint;
      if (!endpoint || !this.logo || !this.logo.data) return Promise.resolve(false);
      var coffees = this.items.filter((it) => this.isCoffee(it)).map((it) => it.title).join(', ').slice(0, 80);
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? window.setTimeout(() => ctrl.abort(), 10000) : 0;
      return fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'x-requested-with': 'kult-b2b' },
        body: JSON.stringify({ referenz: group, firma: '', email: '', kaffee: coffees, dateiname: this.logo.name, logo: this.logo.data, vorschau: '', page: window.location.pathname }),
        signal: ctrl ? ctrl.signal : undefined
      }).then((r) => r.ok).catch(() => false).then((ok) => { window.clearTimeout(timer); return ok; });
    }

    pickMax(list) {
      if (!list.length) return null;
      var best = list[0];
      for (var i = 1; i < list.length; i++) { if (this.priceOf(list[i]) > this.priceOf(best)) best = list[i]; }
      return best;
    }

    onSuggest() {
      this.manual = false;
      this.runSuggestion(true);
      this.setView('overview');
      var box = this.querySelector('.kult-b2bb-box');
      if (box && box.scrollIntoView) box.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
    }

    setView(view) {
      this.dataset.view = view;
      if (view !== 'start') this._interacted = true;
    }

    maybeAutoSuggest() {
      clearTimeout(this._debounce);
      this._debounce = setTimeout(() => { if (!this.manual) this.runSuggestion(true); }, 400);
    }

    runSuggestion(clearFirst) {
      var budgetCents = Math.round((parseFloat(this.budgetInput.value || '0') || 0) * 100);
      var boxPrice = this.priceOf({ gross: this.boxGross, net: this.boxNet }) + this.shipInBudget();
      var cheapest = this.cheapestAllowed();
      this.minHint.hidden = true;
      if (!isFinite(cheapest) || budgetCents < boxPrice + cheapest * this.min) {
        var minEuro = Math.ceil((boxPrice + (isFinite(cheapest) ? cheapest * this.min : 0)) / 100);
        this.minHint.textContent = 'Ab ' + minEuro + ' € pro Präsent stellen wir eine Box zusammen' + (this.shipInBudget() ? ' (inklusive Versand je Adresse)' : '') + '.';
        this.minHint.hidden = false;
        if (clearFirst) this.items = [];
        this.manual = false;
        this.render();
        return;
      }
      var R = budgetCents - boxPrice;
      // Für den Mindestinhalt Budget zurückhalten: je noch fehlendem Platz das günstigste Produkt
      var reserve = (n) => Math.max(0, this.min - n - 1) * cheapest;
      var used = {};
      var catCount = {};
      var result = [];
      this.catOrder.forEach((cat) => {
        if (result.length >= this.max) return;
        var candidates = this.products.filter((p) => p.suggest && p.catKey === cat && !used[p.handle]);
        if (!candidates.length) return;
        var pick = null;
        if (cat === 'kaffee') {
          var best = candidates.filter((p) => p.bestseller && this.costOf(p) <= R - reserve(result.length));
          pick = this.pickMax(best) || this.pickMax(candidates.filter((p) => this.costOf(p) <= R - reserve(result.length)));
        } else {
          pick = this.pickMax(candidates.filter((p) => this.costOf(p) <= R - reserve(result.length)));
        }
        if (pick) { result.push(pick); used[pick.handle] = true; R -= this.costOf(pick); catCount[cat] = (catCount[cat] || 0) + 1; }
      });
      var guard = 0;
      while (result.length < this.max && guard < 200) {
        guard++;
        var pool = this.products.filter((p) => p.suggest && !used[p.handle] && this.costOf(p) <= R - reserve(result.length) && ((catCount[p.catKey] || 0) < 2 || result.length < this.min));
        var next = this.pickMax(pool);
        if (!next) break;
        result.push(next); used[next.handle] = true; R -= this.costOf(next); catCount[next.catKey] = (catCount[next.catKey] || 0) + 1;
      }
      this.items = result.map((p) => {
        var item = Object.assign({}, p);
        if (item.variants && item.variants[this.grind]) item.variant = item.variants[this.grind];
        return item;
      });
      this.manual = false;
      this.swapIndex = null;
      var perGross = this.itemsGrossPerPresent();
      var perNet = this.perNetShown();
      if (!this.items.length) {
        this.statusEl.textContent = 'In diesem Budget passt noch kein Produkt zur Kult-Box. Erhöhen Sie das Budget etwas.';
      } else if (this.mode === 'netto') {
        this.statusEl.textContent = 'Vorschlag für ' + money(budgetCents) + ' netto: ' + this.items.length + (this.items.length === 1 ? ' Produkt' : ' Produkte') + ', ' + money(perNet) + ' netto (' + money(perGross) + ' brutto). Tauschen oder ergänzen Sie nach Wunsch.';
      } else {
        this.statusEl.textContent = 'Vorschlag für ' + money(budgetCents) + ' brutto: ' + this.items.length + (this.items.length === 1 ? ' Produkt' : ' Produkte') + ', ' + money(perGross) + ' brutto (' + money(perNet) + ' netto). Tauschen oder ergänzen Sie nach Wunsch.';
      }
      // Alkohol „Ja“: der Budget-Vorschlag selbst wählt nie Alkohol, danach wird gezielt eines eingesetzt
      if (this.alcoholOn && this.items.length) { var alcMsg = this.ensureAlcohol(); if (alcMsg) this.statusEl.textContent += ' ' + alcMsg; }
      this.render();
    }

    // Produkt darf gezeigt/gewählt werden (Alkohol nur bei Schalter „Ja“)
    allowed(p) { return !p.alcohol || this.alcoholOn; }
    cheapestAllowed() {
      var list = this.products.filter((p) => this.allowed(p));
      return list.length ? Math.min.apply(null, list.map(this.costOf.bind(this))) : Infinity;
    }
    usedHandles() { var u = {}; this.items.forEach((it) => { u[it.handle] = true; }); return u; }
    withGrind(p) { var item = Object.assign({}, p); if (item.variants && item.variants[this.grind]) item.variant = item.variants[this.grind]; return item; }
    closestBy(list, target) {
      var best = null, diff = Infinity;
      list.forEach((p) => { var d = Math.abs(this.costOf(p) - target); if (d < diff) { diff = d; best = p; } });
      return best;
    }

    // Tabs ohne erlaubte Produkte ausblenden (z. B. reine Alkohol-Kategorie bei „Nein“); aktiven Tab ggf. wechseln
    updateTabs() {
      var firstVisible = null, activeHidden = false;
      this.tabs.forEach((t) => {
        var key = t.dataset.b2bbTab;
        var has = this.products.some((p) => p.catKey === key && this.allowed(p));
        t.hidden = !has;
        if (has && !firstVisible) firstVisible = key;
        if (!has && t.getAttribute('aria-selected') === 'true') activeHidden = true;
      });
      if (activeHidden && firstVisible) this.showTab(firstVisible);
      else this.panels.forEach((p) => { if (!p.hidden) this.applyFilters(p); });
    }

    /* Alkohol-Schalter. byUser: Klick (Präsent anpassen, Statuszeile); false: Wiederherstellen aus dem Link (Präsent unverändert) */
    setAlcohol(on, byUser) {
      if (!this.alcoholAvail) return;
      on = !!on;
      this.alcoholPills.forEach((b) => { var a = (b.dataset.b2bbAlcoholPill === 'ja') === on; b.classList.toggle('is-active', a); b.setAttribute('aria-pressed', a ? 'true' : 'false'); });
      var changed = this.alcoholOn !== on;
      this.alcoholOn = on;
      this.updateTabs();
      if (!byUser || !changed) { if (byUser) this.render(); return; }
      this.swapIndex = null;
      var msg = on ? this.ensureAlcohol() : this.removeAlcohol();
      this.statusEl.textContent = msg || (on ? 'Produkte mit Alkohol sind jetzt wählbar.' : 'Ihr Präsent enthält keinen Alkohol.');
      this.render();
    }

    // „Nein“: Alkohol-Produkte ersetzen (gleiche Kategorie, ähnlicher Preis, Budget) oder entfernen
    removeAlcohol() {
      var notes = [];
      for (var i = this.items.length - 1; i >= 0; i--) {
        var it = this.items[i];
        if (!it.alcohol) continue;
        var used = this.usedHandles();
        var avail = this.availableGeneral() + this.costOf(it);
        var pool = this.products.filter((p) => !p.alcohol && p.suggest && p.catKey === it.catKey && !used[p.handle] && this.costOf(p) <= avail);
        var rep = this.closestBy(pool, this.costOf(it));
        if (rep) { this.items[i] = this.withGrind(rep); notes.unshift('„' + it.title + '“ ersetzt durch „' + rep.title + '“'); }
        else { this.items.splice(i, 1); notes.unshift('„' + it.title + '“ entfernt'); }
      }
      return notes.length ? 'Ohne Alkohol: ' + notes.join(', ') + '.' : '';
    }

    // „Ja“: ein Alkohol-Produkt einsetzen (freier Platz + Budget), sonst gegen das preislich nächste Produkt tauschen
    ensureAlcohol() {
      if (!this.alcoholOn || this.items.some((it) => it.alcohol)) return '';
      var used = this.usedHandles();
      var alc = this.products.filter((p) => p.alcohol && !used[p.handle]);
      if (!alc.length) return '';
      if (this.items.length < this.max) {
        var add = this.pickMax(alc.filter((p) => this.costOf(p) <= this.availableGeneral()));
        if (add) { this.items.push(this.withGrind(add)); return 'Mit Alkohol: „' + add.title + '“ hinzugefügt.'; }
      }
      var free = this.availableGeneral();
      var tryCats = (test) => {
        var best = null;
        this.items.forEach((it, i) => {
          if (!test(it)) return;
          var fit = alc.filter((p) => this.costOf(p) <= free + this.costOf(it));
          var c = this.closestBy(fit, this.costOf(it));
          if (!c) return;
          var d = Math.abs(this.costOf(c) - this.costOf(it));
          if (!best || d < best.d) best = { i: i, p: c, d: d };
        });
        return best;
      };
      var swap = tryCats((it) => it.catKey === 'confiserie') || tryCats((it) => it.catKey !== 'kaffee' && it.catKey !== 'confiserie');
      if (!swap) return 'Für ein Produkt mit Alkohol fehlt Platz oder Budget. Entfernen Sie ein Produkt oder erhöhen Sie das Budget.';
      var old = this.items[swap.i];
      this.items[swap.i] = this.withGrind(swap.p);
      return 'Mit Alkohol: „' + old.title + '“ getauscht gegen „' + swap.p.title + '“.';
    }

    showTab(cat) {
      this.tabs.forEach((t) => { var on = t.dataset.b2bbTab === cat; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      this.panels.forEach((p) => { p.hidden = p.dataset.b2bbPanel !== cat; if (!p.hidden) this.applyFilters(p); });
    }

    // Filter-Chips je Panel (Tee-Kategorie, Aroma) wie im B2C-Konfigurator; Alkohol über den Schalter in der Box
    setFilter(chip) {
      var group = chip.dataset.b2bbFilter;
      var panel = chip.closest('[data-b2bb-panel]');
      // Chip „Mit Alkohol“ (06.10.2026): schaltet bei Bedarf den Alkohol-Schalter der Box ein, sonst wäre die Liste leer
      if (group === 'alkohol' && chip.dataset.b2bbValue === 'mit' && !this.alcoholOn && this.alcoholAvail) this.setAlcohol(true, true);
      panel.querySelectorAll('[data-b2bb-filter="' + group + '"]').forEach((c) => {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.applyFilters(panel);
    }

    /* Filter anwenden (Alkohol-Karten nur bei Schalter „Ja“); die Aroma-Chips zeigen nur Aromen, die es in der aktuellen Kategorie-/Alkohol-Auswahl gibt
       (wie im Privatkunden-Konfigurator). Fällt das aktive Aroma weg, springt die Auswahl auf „Alle Aromen“. */
    applyFilters(panel) {
      var active = {};
      // Schalter „Nein“: Filter „Mit Alkohol“ zurück auf alle (Alkohol-Karten sind ohnehin verborgen)
      var mitChip = panel.querySelector('[data-b2bb-filter="alkohol"][data-b2bb-value="mit"].is-active');
      if (mitChip && !this.alcoholOn) {
        panel.querySelectorAll('[data-b2bb-filter="alkohol"]').forEach((c) => { var on = !c.dataset.b2bbValue; c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      panel.querySelectorAll('[data-b2bb-filter].is-active').forEach((c) => { if (c.dataset.b2bbValue) active[c.dataset.b2bbFilter] = c.dataset.b2bbValue; });
      var cards = Array.from(panel.querySelectorAll('[data-b2bb-card]'));
      var matches = (card, keys) => keys.every((key) => (card.dataset[key] || '').split(' ').indexOf(active[key]) !== -1);
      var otherKeys = Object.keys(active).filter((k) => k !== 'aroma');
      var available = new Set();
      var alcOk = (card) => card.dataset.alkohol !== 'mit' || this.alcoholOn;
      cards.forEach((card) => {
        if (alcOk(card) && matches(card, otherKeys)) (card.dataset.aroma || '').split(' ').filter(Boolean).forEach((a) => available.add(a));
      });
      var activeAromaGone = false;
      panel.querySelectorAll('[data-b2bb-filter="aroma"]').forEach((chip) => {
        var val = chip.dataset.b2bbValue;
        if (!val) return;
        var show = available.has(val);
        chip.hidden = !show;
        if (!show && chip.classList.contains('is-active')) {
          chip.classList.remove('is-active');
          chip.setAttribute('aria-pressed', 'false');
          activeAromaGone = true;
        }
      });
      if (activeAromaGone) {
        var all = panel.querySelector('[data-b2bb-filter="aroma"][data-b2bb-value=""]');
        if (all) { all.classList.add('is-active'); all.setAttribute('aria-pressed', 'true'); }
        delete active.aroma;
      }
      cards.forEach((card) => { card.hidden = !alcOk(card) || !matches(card, Object.keys(active)); });
    }

    // Anzeige-Label der gewählten Zubereitung (Setting grind_map), Fallback Variantenwert
    grindLabel() {
      var b = this.grindPills.filter((p) => p.dataset.b2bbGrindPill === this.grind)[0];
      return b ? (b.dataset.label || this.grind) : this.grind;
    }

    selectGrind(btn) {
      this.grind = btn.dataset.b2bbGrindPill;
      this.grindPills.forEach((b) => { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      this.items.forEach((it) => { if (it.variants && it.variants[this.grind]) it.variant = it.variants[this.grind]; });
      this.render();
    }

    availableGeneral() {
      var boxPrice = this.priceOf({ gross: this.boxGross, net: this.boxNet }) + this.shipInBudget();
      var used = this.items.reduce((s, p) => s + this.costOf(p), 0);
      var budgetCents = Math.round((parseFloat(this.budgetInput.value || '0') || 0) * 100);
      return budgetCents - boxPrice - used;
    }

    // Beim Tausch wird der Preis des getauschten Produkts frei, unabhängig von der Kategorie des Ersatzes
    availableFor() {
      var avail = this.availableGeneral();
      if (this.swapIndex !== null && this.items[this.swapIndex]) avail += this.costOf(this.items[this.swapIndex]);
      return avail;
    }

    addProductByIndex(idx, silent) {
      var p = this.products[idx];
      if (!p || !this.allowed(p)) return;
      var item = Object.assign({}, p);
      if (item.variants && item.variants[this.grind]) item.variant = item.variants[this.grind];
      if (this.swapIndex !== null) {
        var si = this.swapIndex;
        this.items[si] = item;
        this.swapIndex = null;
        this.manual = true;
        this.statusEl.textContent = '';
        this.render();
        if (!silent) this.focusSlot(si);
        return;
      }
      if (this.items.length >= this.max) { this.flashError('Ihr Präsent ist voll. Entfernen Sie zuerst ein Produkt.'); return; }
      this.items.push(item);
      this.manual = true;
      this.render();
      if (!silent) this.focusSlot(this.items.length - 1);
    }

    removeSlot(i) {
      this.items.splice(i, 1);
      this.manual = true;
      this.render();
      var btn = this.slotsEl.querySelector('[data-b2bb-remove]');
      if (btn) btn.focus(); else if (this.suggestBtn) this.suggestBtn.focus();
    }

    beginSwap(i) {
      if (this.swapIndex === i) { this.swapIndex = null; this.statusEl.textContent = ''; this.render(); return; }
      this.swapIndex = i;
      var it = this.items[i];
      this.setView('edit');
      this.showTab(it.catKey);
      this.statusEl.textContent = 'Wählen Sie einen Ersatz für „' + it.title + '“, aus dieser oder einer anderen Kategorie. Frei: ' + money(this.availableFor()) + ' (' + this.mode + ').';
      this.render();
      if (window.innerWidth < 960) {
        var tl = this.tabs[0] && this.tabs[0].closest('[role="tablist"]');
        if (tl && tl.scrollIntoView) tl.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
      }
    }

    focusSlot(i) {
      var li = this.slotsEl.children[i];
      var btn = li ? li.querySelector('[data-b2bb-swap]') : null;
      if (btn) btn.focus();
    }

    flashError(msg) {
      this.errorEl.hidden = !msg;
      this.errorEl.innerHTML = msg ? ICON_WARNING + '<span>' + esc(msg) + '</span>' : '';
    }

    updateMeter() {
      var boxPrice = this.priceOf({ gross: this.boxGross, net: this.boxNet });
      var shipIn = this.shipInBudget();
      if (this.shipLine) { this.shipLine.hidden = !shipIn; var sp = this.querySelector('[data-b2bb-ship-inline]'); if (sp) sp.textContent = money(shipIn); }
      var used = boxPrice + shipIn + this.items.reduce((s, p) => s + this.costOf(p), 0);
      var budgetCents = Math.round((parseFloat(this.budgetInput.value || '0') || 0) * 100);
      var rest = budgetCents - ceilCents(used); // Rest aus dem angezeigten (aufgerundeten) Verbrauch, 50,00 − 48,52 = 1,48
      var pct = budgetCents > 0 ? Math.min(100, Math.max(0, (used / budgetCents) * 100)) : 0;
      this.meterBar.style.width = pct + '%';
      this.meterWrap.classList.remove('is-full', 'is-over');
      var modeLabel = this.mode === 'netto' ? 'netto' : 'brutto';
      var text = 'Verwendet ' + money(used) + ' von ' + money(budgetCents) + ' (' + modeLabel + ') · Rest ' + money(Math.max(rest, 0));
      this.overBudget = rest < 0;
      this.budgetFull = false;
      if (this.overBudget) {
        this.meterWrap.classList.add('is-over');
        text = 'Über Budget um ' + money(Math.abs(rest));
      } else {
        var cheapest = this.cheapestAllowed();
        if (isFinite(cheapest) && rest < cheapest) { this.budgetFull = true; this.meterWrap.classList.add('is-full'); text += ' · kein weiteres Produkt passt'; }
      }
      this.meterText.textContent = text;
      var bp = this.querySelector('[data-b2bb-box-price]');
      if (bp) bp.textContent = money(boxPrice);
    }

    updateCards() {
      var swapping = this.swapIndex !== null && !!this.items[this.swapIndex];
      this.cards.forEach((btn, i) => {
        var p = this.products[i];
        var avail = this.availableFor(p.catKey);
        var price = this.costOf(p);
        var over = price - avail;
        var label = btn.querySelector('[data-b2bb-add-label]');
        if (over > 0) { btn.disabled = true; if (label) label.textContent = 'über Budget (+' + money(over) + ')'; btn.setAttribute('aria-label', p.title + ': über Budget, ' + money(over) + ' zu teuer'); }
        else { btn.disabled = false; if (label) label.textContent = 'Hinzufügen'; btn.setAttribute('aria-label', p.title + ' hinzufügen'); }
        var li = btn.closest('[data-b2bb-card]');
        if (li) li.classList.toggle('is-fit', swapping && over <= 0);
      });
    }

    renderSlots() {
      var lis = Array.from(this.slotsEl.querySelectorAll('[data-b2bb-slot]'));
      lis.forEach((li, i) => {
        var it = this.items[i];
        var swapping = this.swapIndex === i;
        li.classList.toggle('is-empty', !it);
        li.classList.toggle('is-swapping', swapping);
        // Leere Plätze nur zeigen, solange im Budget noch ein Produkt Platz hat
        li.hidden = !it && (this.budgetFull || this.overBudget);
        if (!it) { li.innerHTML = '<span class="kult-b2bb-box__slot-empty">Platz ' + (i + 1) + '</span>'; return; }
        var thumb = it.img ? '<img src="' + esc(it.img) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="kult-b2bb-box__slot-thumb-empty" aria-hidden="true"></span>';
        var meta = [it.unit, it.vendor, it.ort].filter(Boolean).join(' · ');
        li.innerHTML = '<span class="kult-b2bb-box__slot-thumb">' + thumb + '</span>' +
          '<span class="kult-b2bb-box__slot-text"><strong>' + '<button type="button" class="kult-b2bb-box__slot-link" data-b2bb-slot-edit="' + i + '" aria-label="' + esc(it.title) + ': Produkte anpassen">' + esc(it.title) + '</button>' + '</strong>' + (meta ? '<small>' + esc(meta) + '</small>' : '') + '</span>' +
          '<span class="kult-b2bb-box__slot-price">' + money(this.priceOf(it)) + '</span>' +
          '<button type="button" class="kult-b2bb-box__slot-swap" data-b2bb-swap="' + i + '" aria-pressed="' + (swapping ? 'true' : 'false') + '" aria-label="' + esc(it.title) + ' tauschen">' + ICON_SWAP + '</button>' +
          '<button type="button" class="kult-b2bb-box__slot-remove" data-b2bb-remove="' + i + '" aria-label="' + esc(it.title) + ' entfernen">' + ICON_CLOSE + '</button>';
      });
    }

    /* Summen der Zusammenfassung (eine Rechnung für updateSums und configJson): Beträge in Cent, Netto-Teilsummen exakt,
       Gesamt netto einmal auf den Cent aufgerundet. „Je Präsent“/„Präsente gesamt“ ohne Services (nicht im Präsent-Budget). */
    totals() {
      var perGross = this.itemsGrossPerPresent(), perNet = this.perNetShown();
      var t = { perGross: perGross, perNet: perNet, itemsGross: perGross * this.qty, itemsNet: perNet * this.qty, shipGross: this.shipTotalGross(), shipNet: this.shipTotalNet(),
        labelGross: this.labelTotal(), labelNet: this.labelTotalNet(), cardGross: this.cardTotal(), cardNet: this.cardTotalNet() };
      t.totalGross = t.itemsGross + t.shipGross + t.labelGross + t.cardGross;
      t.totalNet = ceilCents(t.itemsNet + t.shipNet + t.labelNet + t.cardNet);
      return t;
    }

    updateSums() {
      var t = this.totals();
      // „Je Präsent“ und „Präsente gesamt“ ohne Etikett-Service (Service des Unternehmens, nicht im Präsent-Budget)
      var perGross = t.perGross;
      var perNet = t.perNet;
      // Summen inklusive Versandposition laut Auswahl (Einzelversand je Adresse, Sammellieferung in 10er-/5er-Kartons, Abholung ohne)
      var itemsGross = t.itemsGross;
      var shipGross = t.shipGross;
      var labelGross = t.labelGross;
      var labelNet = t.labelNet;
      // Ein Posten „Etikett-Service“ (Pauschale + Kaffeetüten), Erklärzeile brutto, dazu der Nettobetrag
      var labelRow = this.querySelector('[data-b2bb-sum-label-row]');
      if (labelRow) {
        labelRow.hidden = !(labelGross > 0);
        var lv = labelRow.querySelector('[data-b2bb-sum-label]'); if (lv) lv.textContent = money(labelGross);
        var ln = labelRow.querySelector('[data-b2bb-sum-label-note]');
        if (ln) ln.textContent = labelGross > 0 ? this.labelExplain('brutto') + '; netto ' + money(labelNet) : '';
      }
      // Grußkarten-Service: eigener Posten (Anzahl Kult-Boxen × Preis je Karte), nur im Gesamtbetrag
      var cardGross = t.cardGross;
      var cardNet = t.cardNet;
      var cardRow = this.querySelector('[data-b2bb-sum-card-row]');
      if (cardRow) {
        cardRow.hidden = !(cardGross > 0);
        var cv = cardRow.querySelector('[data-b2bb-sum-card]'); if (cv) cv.textContent = cardGross > 0 ? money(cardGross) : '';
        var cn = cardRow.querySelector('[data-b2bb-sum-card-note]');
        if (cn) cn.textContent = cardGross > 0 ? this.cardExplain() + '; netto ' + money(cardNet) : '';
      }
      var il = this.querySelector('[data-b2bb-sum-items-label]');
      var without = this.serviceNames(labelGross, cardGross);
      if (il) il.textContent = without ? 'Präsente gesamt, brutto (ohne ' + without + ')' : 'Präsente gesamt, brutto';
      var totalGross = t.totalGross;
      var totalNet = t.totalNet;
      this.sumEls.perGross.textContent = money(perGross);
      this.sumEls.perNet.textContent = money(perNet);
      var ig = this.querySelector('[data-b2bb-sum-items-gross]'); if (ig) ig.textContent = money(itemsGross);
      var shipRow = this.querySelector('[data-b2bb-sum-ship-row]');
      if (shipRow) {
        var su = this.shipUnits();
        var viaCheckout = this.checkoutChargesShipping();
        shipRow.hidden = !(su.single || su.mid || su.bulk || viaCheckout);
        var sl = shipRow.querySelector('[data-b2bb-sum-ship-label]'); var sv = shipRow.querySelector('[data-b2bb-sum-ship]');
        if (sl) sl.textContent = viaCheckout ? 'Versand DHL nach Gewicht (in der Kasse)' : this.shipRowLabel();
        if (sv) sv.textContent = viaCheckout ? 'ab ' + (this.dataset.shipFrom || '6,50') + ' € zzgl. MwSt.' : money(shipGross);
        var tg = this.sumEls.totalGross, tn = this.sumEls.totalNet;
        if (tg && tg.previousElementSibling) tg.previousElementSibling.textContent = viaCheckout ? 'Gesamt, brutto, zzgl. Versand' : 'Gesamt, brutto';
        if (tn && tn.previousElementSibling) tn.previousElementSibling.textContent = viaCheckout ? 'Gesamt, netto, zzgl. Versand' : 'Gesamt, netto';
      }
      this.sumEls.totalGross.textContent = money(totalGross);
      this.sumEls.totalNet.textContent = money(totalNet);
      this.sumEls.vat.textContent = money(Math.max(totalGross - totalNet, 0));
    }

    updateSubmitState() {
      var overLimit = this.qty > this.limit;
      var needsGrind = this.hasCoffee() && !this.grind;
      if (this.grindHint) this.grindHint.hidden = !(needsGrind && this._grindAttempt);
      // Kontaktformular: ab Limit+1 Pflicht (Kauf gesperrt), darunter über „Anfrage stellen“ auf-/zuklappbar
      var contactShown = overLimit || this.contactOpen;
      this.contactBlock.hidden = !contactShown;
      if (this.contactToggle) this.contactToggle.setAttribute('aria-expanded', contactShown ? 'true' : 'false');
      this.submitBtn.hidden = overLimit;
      this.submitBtn.disabled = this.items.length === 0 || this.overBudget;
      if (this.minNote) {
        var missing = this.min - this.items.length;
        this.minNote.hidden = !(this.items.length > 0 && missing > 0);
        if (missing > 0) this.minNote.textContent = 'Noch mindestens ' + missing + (missing === 1 ? ' Produkt' : ' Produkte') + ': Ein Präsent hat ' + this.min + ' bis ' + this.max + ' Produkte.';
      }
      if (contactShown) {
        var ctitle = this.contactBlock.querySelector('[data-b2bb-contact-title]');
        if (ctitle) ctitle.textContent = (overLimit ? ctitle.dataset.limit : ctitle.dataset.open) || ctitle.textContent;
        var ctype = this.contactBlock.querySelector('[data-b2bb-contact-type]');
        if (ctype) ctype.value = (overLimit ? ctype.dataset.limit : ctype.dataset.open) || ctype.value;
        var mail = this.contactBlock.querySelector('[data-b2bb-contact-mail]');
        if (mail) mail.href = 'mailto:' + this.dataset.email + '?subject=' + encodeURIComponent('Firmenpräsente Anfrage (' + this.qty + ' Stück)');
        this.fillContact();
      }
      if (this.barEl) {
        this.barEl.hidden = this.items.length === 0;
        var count = this.barEl.querySelector('[data-b2bb-bar-count]');
        var sum = this.barEl.querySelector('[data-b2bb-bar-sum]');
        if (count) count.textContent = this.items.length + (this.items.length === 1 ? ' Produkt' : ' Produkte');
        if (sum) sum.textContent = money(this.priceOf({ gross: this.boxGross, net: this.boxNet }) + this.items.reduce((s, p) => s + this.costOf(p), 0)) + ' je Präsent (' + this.mode + ')';
      }
    }

    /* „Anfrage stellen“ (15.10.2026): Kontaktformular auf-/zuklappen; ab Limit+1 bleibt es offen (Pflicht), der Knopf
       springt dann nur ins Formular. Beim Öffnen Fokus ins erste Formularfeld. */
    toggleContact() {
      if (!this.contactBlock) return;
      var overLimit = this.qty > this.limit;
      if (!overLimit) this.contactOpen = !this.contactOpen;
      this.updateSubmitState();
      if (this.contactBlock.hidden) return;
      var first = this.contactBlock.querySelector('input:not([type="hidden"]):not([tabindex="-1"]), textarea, select');
      if (!first) return;
      first.focus({ preventScroll: true });
      if (first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
    }

    hasCoffee() { return this.items.some((it) => it.variants && Object.keys(it.variants).length); }

    // Klartext-Zusammenfassung für die Kontakt-Anfrage (contact[body])
    configSummary() {
      var labelN = this.labelCount();
      var perGross = this.itemsGrossPerPresent();
      var perNet = this.perNetShown();
      var labelGross = this.labelTotal(), labelNet = this.labelTotalNet();
      var lines = ['Anzahl Präsente: ' + this.qty, 'Budget je Präsent: ' + (this.budgetInput.value || '–') + ' € (' + this.mode + ')'];
      if (this.occasion) lines.push('Anlass: ' + this.occasion);
      var overLimit = this.qty > this.limit;
      lines.push('Versand: ' + this.shippingLabel() + (overLimit ? ' (Versandkosten im Angebot)' : (this.shipTotalGross() ? ' (' + money(this.shipTotalGross()) + ')' : '')));
      if (this.hasCoffee()) lines.push('Zubereitung: ' + (this.grind ? this.grindLabel() : 'noch nicht gewählt'));
      if (this.alcoholAvail) lines.push('Alkohol: ' + (this.alcoholOn ? 'ja' : 'nein'));
      if (labelN) {
        var lineText = 'Etikett-Service (Service, nicht im Präsent-Budget): ';
        var logoText = this.logo ? ', Logo-Datei ' + this.logo.name + (this.logo.quality ? ', Logo-Qualität: ' + this.logo.quality : '') + ' (bitte per E-Mail senden)' : '';
        var priceText = this.labelPriced() ? money(labelGross) + ' brutto / ' + money(labelNet) + ' netto (' + this.labelExplain('netto') + ', netto)' : this.labelPending + ', ' + this.bagsText(this.labelBags());
        if (this.labelSkip()) lineText += 'Kein Etikett-Service nötig, Etiketten bereits vorhanden (Folgeauftrag), ' + this.sortsText(labelN) + ', Bestand bitte prüfen';
        else if (this.labelOwn()) lineText += 'Eigene Gestaltung, Druckdatei folgt per E-Mail an ' + (this.dataset.labelMail || 'uns') + ': ' + priceText + logoText;
        else lineText += priceText + (this.logo ? logoText : ', Logo folgt per E-Mail');
        lines.push(lineText);
      }
      var cardGross = this.cardTotal(), cardNet = this.cardTotalNet();
      if (this.cardActive()) lines.push(this.cardName + ' (Service, nicht im Präsent-Budget): ' + (this.cardOwnActive() ? this.cardOwnText() : this.cardTitle + ', ' + money(cardGross) + ' brutto / ' + money(cardNet) + ' netto (' + this.cardExplain() + ' brutto)'));
      if (this.deliveryDate) lines.push('Wunschliefertermin: ' + this.formatDate(this.deliveryDate));
      if (this.note) lines.push('Anmerkung: ' + this.note);
      lines.push('Zusammenstellung: ' + this.boxTitle + ' (' + money(this.boxGross) + ')' + this.items.map((it) => ', ' + it.title + (it.unit ? ' ' + it.unit : '') + ' (' + money(it.gross) + ')').join(''));
      var without = this.serviceNames(labelGross, cardGross);
      lines.push('Je Präsent: ' + money(perGross) + ' brutto / ' + money(perNet) + ' netto ca.; Präsente gesamt' + (without ? ' (ohne ' + without + ')' : '') + ': ' + money(perGross * this.qty) + ' brutto / ' + money(perNet * this.qty) + ' netto ca.' + (without ? '; Gesamt mit ' + without + ': ' + money(perGross * this.qty + labelGross + cardGross) + ' brutto / ' + money(perNet * this.qty + labelNet + cardNet) + ' netto ca.' : ''));
      lines.push('Link: ' + this.stateUrl().toString());
      return lines.join('\n');
    }

    // Kontaktformular: Klartext (contact[body]) und strukturierte Konfiguration (contact[_konfiguration]) füllen
    fillContact() {
      if (this.contactConfig) this.contactConfig.value = this.configSummary();
      if (this.contactJson) this.contactJson.value = this.configJson();
    }

    /* Strukturierte Konfiguration für Anfrage-Mails und PDF-Übersicht der App (apps/kult-events lib/konfigurator-uebersicht.ts, 19.10.2026).
       Nur eingesammelt (totals, pdfRows, Erklärzeilen), nichts neu gerechnet. Beträge in Cent (Integer, netto wie money() auf den Cent
       aufgerundet); null = Betrag steht noch nicht fest, dann gilt preisText. Positionen = Preis je Präsent, Services/Versand = gesamt.
       Höchstens 3.900 Zeichen (App-Grenze 4.000 je Feld): zuerst entfällt der Link, dann die Anmerkung, sonst leer (nie abgeschnittenes JSON). */
    configJson() {
      var t = this.totals();
      var info = {}; this.pdfRows().forEach((r) => { info[r[0]] = r[1]; });
      var cut = (s, n) => String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, n);
      var overLimit = this.qty > this.limit;
      var viaCheckout = this.checkoutChargesShipping();
      var budget = parseFloat(String(this.budgetInput.value || '').replace(',', '.'));
      var positionen = [{ titel: cut(this.boxTitle, 80), detail: '', brutto: this.boxGross, netto: ceilCents(this.boxNet) }]
        .concat(this.items.map((it) => ({ titel: cut(it.title, 80), detail: cut(it.unit, 40), brutto: it.gross, netto: it.net })));
      var services = [];
      if (this.labelCount()) {
        var logo = this.logo ? ', Logo „' + cut(this.logo.name, 60) + '“' + (this.logo.quality ? ' (' + cut(this.logo.quality, 60) + ')' : '') : '';
        if (this.labelSkip()) services.push({ titel: 'Etikett-Service', text: 'Etiketten vorhanden (Folgeauftrag), ' + this.sortsText(this.labelCount()) + ', Bestand bitte prüfen', brutto: null, netto: null, preisText: 'entfällt' });
        else {
          var priced = this.labelPriced();
          services.push({ titel: 'Etikett-Service', text: cut((this.labelOwn() ? 'Eigene Gestaltung, Druckdatei per E-Mail; ' : '') + (priced ? this.labelExplain('brutto') : this.bagsText(this.labelBags())) + logo, 240),
            brutto: priced ? t.labelGross : null, netto: priced ? ceilCents(t.labelNet) : null, preisText: priced ? '' : cut(this.labelPending, 40) });
        }
      }
      if (this.cardActive()) {
        services.push(this.cardOwnActive()
          ? { titel: cut(this.cardName, 60), text: this.cardOwnText(), brutto: null, netto: null, preisText: 'kostenlos' }
          : { titel: cut(this.cardName, 60), text: cut(this.cardTitle + ', ' + this.cardExplain(), 160), brutto: t.cardGross, netto: ceilCents(t.cardNet) });
      }
      var u = this.shipUnits();
      var versand = overLimit ? { text: cut(this.shippingLabel(), 120), brutto: null, netto: null, preisText: 'im Angebot' }
        : viaCheckout ? { text: 'Versand DHL nach Gewicht (in der Kasse)', brutto: null, netto: null, preisText: 'ab ' + cut(this.dataset.shipFrom || '6,50', 10) + ' € zzgl. MwSt.' }
          : (u.single || u.mid || u.bulk) ? { text: cut(this.shipRowLabel().replace(/^Versand,?\s*/, ''), 160), brutto: t.shipGross, netto: ceilCents(t.shipNet) }
            : { text: cut(this.shippingLabel(), 120), brutto: 0, netto: 0 };
      var data = {
        v: 1, anzahl: this.qty, budget: isNaN(budget) ? null : Math.round(budget * 100), modus: this.mode,
        fuer: cut(info['Für'], 60), anlass: cut(info['Anlass'], 80), versandArt: cut(this.shippingLabel(), 80),
        zubereitung: cut(info['Zubereitung'], 60), alkohol: cut(info['Alkohol'], 10), wunschtermin: cut(info['Wunschliefertermin'], 20), anmerkung: cut(info['Anmerkung'], 500),
        positionen: positionen, services: services, versand: versand,
        summen: { jePraesentBrutto: t.perGross, jePraesentNetto: t.perNet, praesenteBrutto: t.itemsGross, praesenteNetto: ceilCents(t.itemsNet),
          gesamtBrutto: overLimit ? t.totalGross - t.shipGross : t.totalGross, gesamtNetto: overLimit ? ceilCents(t.itemsNet + t.labelNet + t.cardNet) : t.totalNet,
          zzglVersand: overLimit || viaCheckout },
        link: this.stateUrl().toString().slice(0, 600)
      };
      var json = JSON.stringify(data);
      if (json.length > 3900) { data.link = ''; json = JSON.stringify(data); }
      if (json.length > 3900) { data.anmerkung = ''; json = JSON.stringify(data); }
      return json.length > 3900 ? '' : json;
    }

    /* Budget-Schnellwahl: aktive Pille zeigt den Wert im Zahlenfeld (UX-Review 04.10.2026) */
    syncPills() {
      if (!this.pillButtons || !this.budgetInput) return;
      const val = String(parseInt(this.budgetInput.value, 10) || '');
      this.pillButtons.forEach((b) => { const on = b.dataset.b2bbPill === val; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    }

    render() {
      this.syncPills();
      this.grindWrap.hidden = !this.hasCoffee();
      this.updateLabel();
      this.updateCard();
      this.updateMeter();
      this.updateCards();
      this.renderSlots();
      this.updateSums();
      this.updateSubmitState();
      /* Jugendschutz: Hinweis, sobald ein Produkt mit Alkohol im Präsent liegt */
      var alcoholNote = this.querySelector('[data-b2bb-alcohol]');
      if (alcoholNote) alcoholNote.hidden = !this.items.some((it) => it.alcohol);
      this.syncUrl();
    }

    syncUrl() {
      if (!this._interacted) return; // erst nach einer Nutzeraktion in die Adresszeile schreiben
      window.history.replaceState(null, '', this.stateUrl().toString());
    }

    /* Adresse mit dem aktuellen Stand (auch für den Link in der Anfrage ab 101 Präsenten, Testlauf 10.10.2026: anzahl=1) */
    stateUrl() {
      var url = new URL(window.location.href);
      var fuer = this.fuerButtons.filter((b) => b.getAttribute('aria-checked') === 'true')[0];
      if (fuer) url.searchParams.set('fuer', fuer.dataset.b2bbFuer); else url.searchParams.delete('fuer');
      if (this.budgetInput.value) url.searchParams.set('budget', this.budgetInput.value); else url.searchParams.delete('budget');
      url.searchParams.set('modus', this.mode);
      if (this.items.length) url.searchParams.set('box', this.items.map((it) => it.handle).join(',')); else url.searchParams.delete('box');
      url.searchParams.set('anzahl', this.qty);
      if (this.grind) url.searchParams.set('zub', this.grind); else url.searchParams.delete('zub');
      if (this.alcoholOn) url.searchParams.set('alkohol', 'ja'); else url.searchParams.delete('alkohol');
      if (this.occasion) url.searchParams.set('anlass', this.occasion); else url.searchParams.delete('anlass');
      url.searchParams.set('versand', this.shipping);
      var labelUrl = this.labelOn && this.labelAvail;
      if (labelUrl) url.searchParams.set('etikett', '1'); else url.searchParams.delete('etikett');
      url.searchParams.delete('etiketten'); // Staffel-Parameter älterer Links (bis 14.10.2026) entfällt
      if (labelUrl && this.labelStock) url.searchParams.set('lager', this.labelReason === 'eigen' ? 'eigen' : '1'); else url.searchParams.delete('lager');
      // Grußkarten-Service: karte=1 (Karte je Kult-Box) | karte=eigen (eigene Grußkarten, kostenlos beigelegt)
      if (this.cardActive()) url.searchParams.set('karte', this.cardOwn ? 'eigen' : '1'); else url.searchParams.delete('karte');
      return url;
    }

    restoreFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var hasParams = false;
      /* Empfänger-Seiten (Seiten-Metafeld custom.fuer = kunden | mitarbeiter): „Für wen“ vorwählen, solange die Adresse nichts nennt */
      var fuer = params.get('fuer') || this.dataset.defaultFuer || '';
      if (fuer) {
        var fbtn = this.fuerButtons.filter((b) => b.dataset.b2bbFuer === fuer)[0];
        if (fbtn) { this.selectFuer(fbtn); if (params.get('fuer')) hasParams = true; }
      }
      var budget = params.get('budget');
      if (budget) { this.budgetInput.value = budget; hasParams = true; }
      var modus = params.get('modus');
      if (modus === 'netto' || modus === 'brutto') { this.setMode(modus); hasParams = true; }
      /* Anlass-Seiten (Seiten-Metafeld custom.anlass): Anlass vorwählen, solange die Adresse keinen nennt */
      var anlass = params.get('anlass') || this.dataset.defaultOccasion || '';
      if (anlass) { var oc = this.occasionCards.filter((c) => c.dataset.b2bbOcc === anlass && !c.closest('[hidden]'))[0]; if (oc) { this.setOccasion(oc); if (params.get('anlass')) hasParams = true; /* Anlass-Seite: Budget und Modus der Karte übernehmen, solange der Link nichts anderes nennt (Cowork-Test 06.10.2026, Abw. 22) */ if (!params.get('budget') && oc.dataset.b2bbOccBudget) this.budgetInput.value = oc.dataset.b2bbOccBudget; if (!params.get('modus') && oc.dataset.b2bbOccModus) this.setMode(oc.dataset.b2bbOccModus); } }
      var versand = params.get('versand');
      if (versand) { var sb = this.shipButtons.filter((b) => b.dataset.b2bbShip === versand)[0]; if (sb) { this.shipping = versand; this.shipButtons.forEach((b) => { var on = b === sb; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); }); this.updateShipNote(); } }
      var zub = params.get('zub');
      if (zub) { var gp = this.grindPills.filter((b) => b.dataset.b2bbGrindPill === zub)[0]; if (gp) this.selectGrind(gp); }
      // vor box=: Alkohol-Produkte aus dem Link nur bei alkohol=ja übernehmen
      if (params.get('alkohol') === 'ja' && this.alcoholAvail) { this.setAlcohol(true, false); hasParams = true; }
      if (params.get('etikett') === '1' && this.labelAvail) {
        this.labelOn = true;
        // etiketten=<n> (Staffel aus älteren Links) wird ignoriert
        if (params.get('lager') === '1' || params.get('lager') === 'eigen') { this.labelStock = true; this.labelReason = params.get('lager') === 'eigen' ? 'eigen' : 'vorhanden'; }
      }
      var karte = params.get('karte');
      if ((karte === '1' || karte === 'eigen') && this.cardAvail) { this.cardOn = true; this.cardOwn = karte === 'eigen'; }
      var box = params.get('box');
      if (box) {
        hasParams = true;
        var missing = 0;
        box.split(',').forEach((handle) => {
          var clean = handle.replace(/[^a-z0-9-]/g, '');
          var idx = this.products.findIndex((p) => p.handle === clean);
          if (idx > -1) { if (this.items.length < this.max) this.addProductByIndex(idx, true); }
          else missing++;
        });
        // Ausverkaufte Produkte werden serverseitig nicht mehr gerendert: Artikel aus älteren Links fehlen dann hier
        if (missing && this.statusEl) this.statusEl.textContent = missing === 1 ? 'Ein Artikel aus Ihrem Link ist derzeit nicht verfügbar und wurde aus dem Präsent entfernt.' : missing + ' Artikel aus Ihrem Link sind derzeit nicht verfügbar und wurden aus dem Präsent entfernt.';
      }
      this.editGroup = params.get('edit') || '';
      if (this.editGroup) {
        var note = this.querySelector('[data-b2bb-edit-note]'); if (note) note.hidden = false;
        if (this.submitBtn) this.submitBtn.textContent = 'Änderung speichern';
      }
      // Anzahl aus dem Warenkorb übernehmen (kann dort inzwischen geändert worden sein)
      if (this.editGroup) {
        fetch('/cart.js').then((r) => r.json()).then((cart) => {
          var boxLine = (cart.items || []).filter((it) => it.properties && it.properties._kultb2b === this.editGroup && it.properties._kultb2b_box)[0];
          if (boxLine && boxLine.quantity !== this.qty) { this.qty = boxLine.quantity; if (this.qtyInput) this.qtyInput.value = this.qty; this.render(); }
        }).catch(() => {});
      }
      var anzahl = params.get('anzahl');
      if (anzahl) { this.qty = Math.max(1, parseInt(anzahl, 10) || 1); if (this.qtyInput) this.qtyInput.value = this.qty; hasParams = true; }
      // Nur eine geteilte Zusammenstellung (box=…) sperrt den automatischen Vorschlag; Budget/Modus allein lösen ihn aus
      this.manual = !!box;
      if (box) this.setView('overview');
      if (hasParams && !box) { this.maybeAutoSuggest(); this.setView('overview'); }
      /* Anlass-Teaser (06.10.2026): Link ?anlass=…#konfigurator – nach dem Vorbelegen zum Konfigurator scrollen (Scroll-Container ist nicht zwingend window) */
      if (params.get('anlass') && window.location.hash) {
        var jump = document.getElementById(window.location.hash.slice(1));
        if (jump) window.setTimeout(() => { jump.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' }); }, 150);
      }
    }

    /* Klick auf ein Produkt im Präsent: Ansicht „Produkte anpassen“ mit der Kategorie des Produkts, Karte kurz hervorgehoben */
    editSlot(i) {
      var it = this.items[i];
      if (!it) return;
      this._interacted = true;
      this.setView('edit');
      if (it.catKey) this.showTab(it.catKey);
      var btn = this.cards.filter((b) => b.dataset.handle === it.handle)[0];
      var card = btn && btn.closest('[data-b2bb-card]');
      if (!card) return;
      card.classList.add('is-highlight');
      setTimeout(() => card.classList.remove('is-highlight'), 2000);
      if (card.scrollIntoView) card.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
    }

    /* ---------- Unverbindliche Übersicht als PDF (06.10.2026): eine A4-Seite als Bild (assets/kult-pdf.js), links die
       Kult-Box-Vorschau aus der Section kult-b2b-logo-box der Seite (mit hochgeladenem Logo und Schleife in der Logo-Farbe,
       sonst das Standardbild), rechts die Angaben, darunter Zusammenstellung, Summen und eine klickbare Fläche mit dem
       Link zur Konfiguration (Teilen-Link). ---------- */
    pdfRows() {
      var fuer = this.fuerButtons.filter((b) => b.getAttribute('aria-checked') === 'true')[0];
      var rows = [];
      var txt = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
      if (fuer) rows.push(['Für', txt(fuer.querySelector('strong, .kult-b2bb-step1__fuer-title') || fuer)]);
      if (this.occasion) { var oc = this.occasionCards.filter((c) => c.dataset.b2bbOcc === this.occasion)[0]; rows.push(['Anlass', txt(oc && oc.querySelector('.kult-b2bb-occ__title')) || this.occasion]); }
      rows.push(['Anzahl Präsente', String(this.qty)]);
      rows.push(['Budget je Präsent', (this.budgetInput.value || '–') + ' € ' + this.mode]);
      if (this.hasCoffee()) rows.push(['Zubereitung', this.grind ? this.grindLabel() : 'noch nicht gewählt']);
      if (this.alcoholAvail) rows.push(['Alkohol', this.alcoholOn ? 'ja' : 'nein']);
      rows.push(['Versand', this.shippingLabel() + (this.shipTotalGross() ? ' (' + money(this.shipTotalGross()) + ')' : '')]);
      var labelN = this.labelCount();
      if (labelN) {
        var lt = '';
        var explain = this.labelPriced() ? this.labelExplain() + ' (' + this.mode + ')' : this.labelPending + ', ' + this.bagsText(this.labelBags());
        if (this.labelSkip()) lt = 'Kein Etikett-Service nötig, Etiketten vorhanden (' + this.sortsText(labelN) + ')';
        else if (this.labelOwn()) lt = 'Eigene Gestaltung, Druckdatei folgt per E-Mail, ' + explain;
        else lt = explain;
        if (this.logo) lt += ', Logo „' + this.logo.name + '“' + (this.logo.quality ? ' (' + this.logo.quality + ')' : '');
        rows.push(['Etikett-Service', lt]);
      }
      if (this.cardActive()) rows.push([this.cardName, this.cardOwnActive() ? this.cardOwnText() : this.cardTitle + ', ' + this.cardExplain() + ' (' + this.mode + ')']);
      if (this.deliveryDate) rows.push(['Wunschliefertermin', this.formatDate(this.deliveryDate)]);
      if (this.note) rows.push(['Anmerkung', this.note]);
      return rows.filter((r) => !!r[1]);
    }

    /* Kult-Box-Vorschau: Logo aus dem Ereignis der Logo-Section, Variante passend zum ersten Kaffee im Präsent */
    pdfBox() {
      var box = document.querySelector('kult-b2b-logo-box');
      if (!box || !window.KultPdf) return Promise.resolve(null);
      var coffee = this.items.filter((it) => it.variants)[0];
      var opts = { handle: coffee ? coffee.handle : '' };
      if (!this.logo || !this.logo.data) return window.KultPdf.composeBox(box, opts);
      return window.KultPdf.loadImage(this.logo.data, false).then((img) => { opts.logo = img; return window.KultPdf.composeBox(box, opts); }).catch(() => null);
    }

    drawPdfPage(boxCanvas) {
      var W = 595.28, H = 841.89, S = 2.6, M = 48;
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(W * S); canvas.height = Math.round(H * S);
      var ctx = canvas.getContext('2d');
      ctx.scale(S, S);
      var cs = getComputedStyle(this);
      var css = (name, fallback) => cs.getPropertyValue(name).trim() || fallback;
      var heading = css('--font-heading', 'Georgia, serif'), body = css('--font-body', 'Helvetica, Arial, sans-serif');
      var ink = css('--color-text', 'black'), soft = css('--color-text-soft', 'dimgray'), gold = css('--color-brand-gold', 'goldenrod'), line = css('--color-hairline', 'lightgray'), studio = css('--color-studio', 'whitesmoke');
      var wrap = (text, x, y, maxW, lh) => {
        var words = String(text).split(/\s+/), row = '';
        var flush = () => { if (row) { ctx.fillText(row, x, y); y += lh; row = ''; } };
        words.forEach((word) => {
          while (ctx.measureText(word).width > maxW) { flush(); var cut = word.length; while (cut > 1 && ctx.measureText(word.slice(0, cut)).width > maxW) cut--; ctx.fillText(word.slice(0, cut), x, y); y += lh; word = word.slice(cut); }
          var next = row ? row + ' ' + word : word;
          if (ctx.measureText(next).width > maxW) { flush(); row = word; } else row = next;
        });
        flush();
        return y;
      };
      var caps = (text, x, y) => { ctx.fillStyle = soft; ctx.font = '600 7px ' + body; ctx.fillText(String(text).toUpperCase(), x, y); };
      var right = (text, x, y) => { ctx.textAlign = 'right'; ctx.fillText(text, x, y); ctx.textAlign = 'left'; };
      ctx.fillStyle = 'white'; ctx.fillRect(0, 0, W, H);
      ctx.textBaseline = 'alphabetic'; ctx.textAlign = 'left';
      /* Kopf */
      ctx.fillStyle = ink; ctx.font = '500 19px ' + heading; ctx.fillText(this.dataset.shopName || '', M, 60);
      ctx.fillStyle = soft; ctx.font = '600 8px ' + body; right((this.dataset.pdfTitle || 'Unverbindliche Übersicht').toUpperCase(), W - M, 48);
      ctx.font = '400 9px ' + body; right('Stand: ' + new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }), W - M, 62);
      ctx.fillStyle = gold; ctx.fillRect(M, 74, W - 2 * M, 1);
      /* Titel */
      ctx.fillStyle = ink; ctx.font = '500 26px ' + heading; ctx.fillText('Ihr Firmenpräsent', M, 110);
      ctx.fillStyle = soft; ctx.font = '400 10.5px ' + body; ctx.fillText(this.boxTitle + ' · ' + this.qty + ' Stück', M, 127);
      /* Kult-Box links */
      var ix = M, iy = 146, iw = 204, ih = 170;
      if (boxCanvas) {
        ih = Math.min(240, Math.round(iw * boxCanvas.height / boxCanvas.width));
        ctx.drawImage(boxCanvas, 0, 0, boxCanvas.width, boxCanvas.height, ix, iy, iw, ih);
        ctx.fillStyle = soft; ctx.font = '400 8.5px ' + body;
        wrap(this.logo ? 'Vorschau mit Ihrem Logo „' + this.logo.name + '“, Schleife in Ihrer Logo-Farbe. Die finale Gestaltung stimmen wir vor dem Druck mit Ihnen ab.' : 'Die Kult-Box, auf Wunsch mit Ihrem Logo auf dem Kaffee (Etikett-Service).', ix, iy + ih + 12, iw, 11);
        ih += 30;
      } else { ctx.fillStyle = studio; ctx.fillRect(ix, iy, iw, ih); }
      /* Angaben rechts */
      var x = ix + iw + 28, w = W - M - x, y = iy + 8;
      this.pdfRows().forEach((r, i, all) => {
        caps(r[0], x, y);
        ctx.fillStyle = ink; ctx.font = '400 10.5px ' + body;
        y = wrap(r[1], x, y + 12, w, 13);
        if (i < all.length - 1) { ctx.fillStyle = line; ctx.fillRect(x, y - 7, w, 0.5); }
        y += 5;
      });
      /* Zusammenstellung */
      var ny = Math.max(iy + ih, y) + 22;
      caps('Zusammenstellung je Präsent', M, ny); ny += 14;
      var items = [{ title: this.boxTitle, meta: 'Verpackung, immer enthalten', price: this.priceOf({ gross: this.boxGross, net: this.boxNet }) }]
        .concat(this.items.map((it) => ({ title: it.title, meta: [it.unit, it.vendor, it.ort].filter(Boolean).join(' · '), price: this.priceOf(it) })));
      items.forEach((it) => {
        ctx.fillStyle = ink; ctx.font = '500 10.5px ' + body; ctx.fillText(it.title, M, ny);
        ctx.font = '400 10.5px ' + body; right(money(it.price), W - M, ny);
        ny += 12;
        if (it.meta) { ctx.fillStyle = soft; ctx.font = '400 8.5px ' + body; ctx.fillText(it.meta, M, ny); ny += 10; }
        ctx.fillStyle = line; ctx.fillRect(M, ny - 5, W - 2 * M, 0.5);
        ny += 7;
      });
      /* Summen */
      var perGross = this.itemsGrossPerPresent(), perNet = this.perNetShown();
      var labelGross = this.labelTotal(), labelNet = this.labelTotalNet();
      var shipG = this.shipTotalGross(), shipN = this.shipTotalNet();
      var sums = [['Je Präsent', money(perGross) + ' brutto / ' + money(perNet) + ' netto ca.'], ['Präsente gesamt (' + this.qty + ' Stück)', money(perGross * this.qty) + ' brutto / ' + money(perNet * this.qty) + ' netto ca.']];
      if (shipG) sums.push(['Versand (' + this.shippingLabel() + ')', money(shipG) + ' brutto / ' + money(shipN) + ' netto']);
      if (labelGross) sums.push(['Etikett-Service', money(labelGross) + ' brutto / ' + money(labelNet) + ' netto']);
      var cardG = this.cardTotal(), cardN = this.cardTotalNet();
      if (cardG) sums.push([this.cardName + ' (' + this.boxesText(this.qty) + ')', money(cardG) + ' brutto / ' + money(cardN) + ' netto']);
      if (shipG || labelGross || cardG) sums.push(['Gesamt', money(perGross * this.qty + shipG + labelGross + cardG) + ' brutto / ' + money(perNet * this.qty + shipN + labelNet + cardN) + ' netto ca.']);
      ctx.fillStyle = studio; ctx.fillRect(M, ny, W - 2 * M, 14 + sums.length * 15);
      var sy = ny + 14;
      sums.forEach((r, i) => {
        ctx.fillStyle = ink; ctx.font = (i === sums.length - 1 ? '500 ' : '400 ') + '10.5px ' + body;
        ctx.fillText(r[0], M + 12, sy); right(r[1], W - M - 12, sy); sy += 15;
      });
      ny = sy + 14;
      /* Klickbarer Knopf: Konfiguration öffnen (Teilen-Link). Ohne Roh-URL (steckt in der klickbaren
         Fläche der ganzen Zeile); Gestaltung wie im Einzelkauf-PDF (kult-b2b-mischung.js). */
      var fy = H - 70;
      var uri = window.location.href, bx = M, bw = W - 2 * M, bh = 30, br = 15, pw = 196;
      var by = Math.min(ny, fy - 24 - bh);
      if (by < ny) { ctx.fillStyle = 'white'; ctx.fillRect(bx, by - 6, bw, bh + 12); }
      ctx.fillStyle = ink;
      ctx.beginPath();
      ctx.moveTo(bx + br, by);
      ctx.arcTo(bx + pw, by, bx + pw, by + bh, br);
      ctx.arcTo(bx + pw, by + bh, bx, by + bh, br);
      ctx.arcTo(bx, by + bh, bx, by, br);
      ctx.arcTo(bx, by, bx + pw, by, br);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'white'; ctx.font = '600 10px ' + body; ctx.textAlign = 'center';
      ctx.fillText('Konfiguration online öffnen', bx + pw / 2, by + 19);
      ctx.textAlign = 'left';
      ctx.fillStyle = soft; ctx.font = '400 9px ' + body;
      wrap('Der Knopf öffnet Ihre gespeicherte Konfiguration im Browser – dort anpassen und bestellen.', bx + pw + 14, by + 19, bw - pw - 14, 12);
      canvas.kultLink = { uri: uri, rect: [bx, H - (by + bh), bx + bw, H - by] };
      ny = by + bh + 16;
      /* Hinweis: erst messen (unsichtbar), bei Platzmangel kleiner setzen und über der Fußzeile beschneiden */
      var noteText = this.dataset.pdfNote || '';
      ctx.fillStyle = soft; ctx.font = '400 8.5px ' + body;
      ctx.save(); ctx.globalAlpha = 0;
      var probeEnd = wrap(noteText, M, ny + 6, W - 2 * M, 11);
      ctx.restore();
      if (probeEnd > fy - 12) ctx.font = '400 7.5px ' + body;
      ctx.save(); ctx.beginPath(); ctx.rect(M, ny - 4, W - 2 * M, fy - 8 - (ny - 4)); ctx.clip();
      ctx.fillStyle = soft;
      wrap(noteText, M, ny + 6, W - 2 * M, probeEnd > fy - 12 ? 10 : 11);
      ctx.restore();
      ctx.fillStyle = gold; ctx.fillRect(M, fy, W - 2 * M, 1);
      var colW = (W - 2 * M - 40) / 3;
      [[this.dataset.shopName || 'Kontakt', this.dataset.shopAddress || ''], ['Telefon', this.dataset.shopPhone || ''], ['E-Mail', this.dataset.shopEmail || '']].filter((c) => !!c[1]).forEach((c, i) => {
        var cx = M + i * (colW + 20);
        caps(c[0], cx, fy + 18);
        ctx.fillStyle = ink; ctx.font = '400 10px ' + body; wrap(c[1], cx, fy + 31, colW, 13);
      });
      return canvas;
    }

    downloadPdf() {
      if (this.pdfBusy || !window.KultPdf) return;
      if (!this.items.length) { this.copyStatus.textContent = 'Bitte stellen Sie zuerst Ihr Präsent zusammen.'; return; }
      this.pdfBusy = true;
      var say = (t) => { this.copyStatus.textContent = t; };
      say('Die Übersicht wird erstellt.');
      this.syncUrl();
      this.pdfBox().then((boxCanvas) => {
        var page = window.KultPdf.pageFromCanvas(this.drawPdfPage(boxCanvas));
        window.KultPdf.download(window.KultPdf.build([page]), 'Firmenpraesent-Uebersicht.pdf');
        say('Die Übersicht wurde als PDF gespeichert. Sie ist unverbindlich.');
      }).catch(() => { say('Das PDF konnte nicht erstellt werden. Bitte nutzen Sie den Link zum Teilen.'); })
        .then(() => { this.pdfBusy = false; setTimeout(() => { if (!this.pdfBusy) this.copyStatus.textContent = ''; }, 6000); });
    }

    copyLink() {
      var url = window.location.href;
      var done = () => {
        this.copyStatus.textContent = 'Link zur Konfiguration kopiert';
        setTimeout(() => { this.copyStatus.textContent = ''; }, 3000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(() => { window.prompt('Link kopieren:', url); done(); });
      } else {
        window.prompt('Link kopieren:', url);
        done();
      }
    }

    submit() {
      if (!this.items.length || this.overBudget) return;
      if (this.items.length < this.min) {
        this.flashError('Ein Präsent hat ' + this.min + ' bis ' + this.max + ' Produkte. Bitte ergänzen Sie noch ' + (this.min - this.items.length) + '.');
        return;
      }
      var group = this.editGroup || ('B2B-' + Date.now().toString(36).toUpperCase());
      var hasCoffee = this.hasCoffee();
      if (hasCoffee && !this.grind) {
        this._grindAttempt = true;
        this.flashError('Bitte wählen Sie zuerst eine Zubereitung für die Kaffees.');
        this.updateSubmitState();
        if (this.grindWrap.scrollIntoView) this.grindWrap.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
        if (this.grindPills[0]) this.grindPills[0].focus({ preventScroll: true });
        return;
      }
      if (!this.checkDate()) { this.dateInput.focus(); return; }
      var labelN = this.labelCount();
      var labelStock = labelN > 0 && this.labelSkip();
      var labelOwn = labelN > 0 && this.labelOwn();
      var labelCharge = labelN > 0 && this.labelCharged();
      if (labelN && !labelStock && !labelOwn && !this.logo) {
        this.flashError('Bitte laden Sie zuerst Ihr Logo hoch. Ohne Logo können wir Ihr Etikett nicht vorbereiten.');
        var href = this.labelTest ? this.labelTest.getAttribute('href') || '' : '';
        var target = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
        if (target && target.scrollIntoView) target.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
        return;
      }
      var contents = this.items.map((it) => it.title).join(', ');
      var fuerBtn = this.fuerButtons.filter((b) => b.getAttribute('aria-checked') === 'true')[0];
      var boxProps = { _kultb2b: group, _kultb2b_box: '1', _kultb2b_fuer: this.fuer, _kultb2b_modus: this.mode, _kultb2b_budget: String(this.budgetInput.value || ''), _kultb2b_ship: this.shipping, _kultb2b_url: window.location.href, 'Firmenpräsent': 'Verpackung · Inhalt: ' + contents };
      if (fuerBtn) boxProps['Empfänger'] = fuerBtn.textContent.trim();
      if (this.budgetInput.value) boxProps['Budget je Präsent'] = this.budgetInput.value + ' € ' + this.mode;
      if (this.occasion) boxProps['Anlass'] = this.occasion;
      // Versandart als Klartext für Bestellung und Admin (Einzelversand: Adressliste folgt per CSV-Vorlage)
      boxProps['Versand'] = this.shippingLabel() + (this.shipping === 'einzeln' ? ' – Einzelversand an unterschiedliche Empfängeradressen, eine je Präsent; Adressvorlage (CSV) kommt nach der Bestellung per E-Mail' : this.shipping === 'abholung' ? ' – Abholung in der Rösterei' : ' – Sammellieferung an die Adresse im Checkout');
      if (this.shipping === 'einzeln') boxProps['Adressliste'] = 'Sie erhalten nach der Bestellung unsere Adressvorlage (CSV) per E-Mail und senden uns die ausgefüllte Liste zurück; in der Kasse nur die Firmenanschrift angeben';
      if (hasCoffee) boxProps['Zubereitung'] = this.grindLabel();
      if (this.alcoholAvail) boxProps['Alkohol'] = this.alcoholOn ? 'ja' : 'nein';
      if (this.deliveryDate) boxProps['Wunschliefertermin'] = this.deliveryDate;
      if (this.note) boxProps['Anmerkung'] = this.note;
      if (labelN) {
        boxProps._kultb2b_label = '1';
        if (labelStock) { boxProps._kultb2b_label_stock = '1'; boxProps['Etikett-Service'] = 'Etiketten aus Lager (Firma: wird beim Packen geprüft)'; }
        else if (labelOwn) { boxProps._kultb2b_label_design = 'eigen'; boxProps['Etikett-Service'] = 'Eigene Gestaltung, Druckdatei folgt per E-Mail'; }
        else boxProps['Etikett-Service'] = (labelCharge ? this.labelExplain('netto') + ' netto' : this.labelPending) + ', Logo-Datei: ' + this.logo.name;
      }
      // Grußkarten-Service: Hinweis an der Kult-Box-Zeile; eigene Grußkarten → keine Position (0 €)
      var cardCharge = this.cardCharged();
      if (this.cardActive()) {
        boxProps._kultb2b_card = this.cardOwn ? 'eigen' : '1';
        boxProps[this.cardName] = this.cardOwn ? this.cardOwnText() : this.cardTitle + ', ' + this.cardExplain() + ' brutto';
      }
      var lines = [{ id: this.boxVariant, quantity: this.qty, properties: boxProps }];
      this.items.forEach((it, i) => {
        var props = { _kultb2b: group, 'Firmenpräsent': 'Inhalt ' + (i + 1) + ' von ' + this.items.length };
        if (it.variants && Object.keys(it.variants).length) props['Zubereitung'] = this.grindLabel();
        lines.push({ id: it.variant, quantity: this.qty, properties: props });
      });
      // Grußkarten-Service (18.10.2026): eine Position, Menge = Anzahl Kult-Boxen (Service, nicht Teil des Präsents)
      if (cardCharge) lines.push({ id: this.cardVar.id, quantity: this.qty, properties: { _kultb2b: group, _kultb2b_card_line: '1', 'Firmenpräsent': this.cardName + ': ' + this.cardTitle + ' (' + this.boxesText(this.qty) + ')' } });
      // Versandposition (Produkt „Versandkosten innerhalb Deutschland (DHL)“) je nach Versandauswahl
      var shipUnits = this.shipUnits();
      if (shipUnits.bulk > 0 && this.shipBulkVariant) lines.push({ id: this.shipBulkVariant, quantity: shipUnits.bulk, properties: { _kultb2b: group, _kultb2b_ship_line: this.shipping, _kultb2b_ship_kind: 'bulk', 'Firmenpräsent': 'Versand: ' + this.shippingLabel() } });
      if (shipUnits.mid > 0 && this.shipMidVariant) lines.push({ id: this.shipMidVariant, quantity: shipUnits.mid, properties: { _kultb2b: group, _kultb2b_ship_line: this.shipping, _kultb2b_ship_kind: 'mid', 'Firmenpräsent': 'Versand: ' + this.shippingLabel() } });
      if (shipUnits.single > 0 && this.shipSingleVariant) lines.push({ id: this.shipSingleVariant, quantity: shipUnits.single, properties: { _kultb2b: group, _kultb2b_ship_line: this.shipping, _kultb2b_ship_kind: 'single', 'Firmenpräsent': 'Versand: ' + this.shippingLabel() } });
      try { window.localStorage.setItem('kult:b2b', '1'); } catch (err) { /* kein Speicher */ }
      this.submitBtn.disabled = true;
      this.submitBtn.classList.add('is-loading');
      this.flashError('');
      // Bearbeitungsmodus: alte Zeilen der Gruppe zuerst entfernen, dann die neuen anlegen
      var removeOld = () => this.editGroup
        ? fetch('/cart.js').then((r) => r.json()).then((cart) => {
            var updates = {};
            (cart.items || []).forEach((it) => { if (it.properties && it.properties._kultb2b === this.editGroup) updates[it.key] = 0; });
            if (!Object.keys(updates).length) return null;
            return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
          })
        : Promise.resolve(null);
      // Etikett-Service (15.10.2026): Logo zuerst senden, dann einmal die Pauschale (Bearbeitung & Druck, Menge 1) und die
      // Position „Etikett je Kaffeetüte“ mit Menge = Kaffeetüten der Bestellung. Auch bei eigener Gestaltung (nur andere
      // Eigenschaften). „Etiketten auf Lager“: keine Positionen, kein Logo nötig.
      var logoJob = labelN && !labelStock ? this.sendLogo(group) : Promise.resolve(false);
      logoJob.then((sent) => {
        if (labelCharge) {
          var state = sent ? 'übermittelt' : 'bitte per E-Mail an ' + (this.dataset.labelMail || 'uns') + ' senden';
          var labelProps = (extra) => {
            var lp = Object.assign({ _kultb2b: group }, extra, { 'Logo-Referenz': group });
            if (this.logo) { lp['Logo-Datei'] = this.logo.name; if (this.logo.quality) lp['Logo-Qualität'] = this.logo.quality; lp['Logo'] = state; }
            if (labelOwn) { lp['Gestaltung'] = 'Eigene Gestaltung, Druckdatei folgt per E-Mail'; if (!this.logo) lp['Druckdatei'] = 'bitte per E-Mail an ' + (this.dataset.labelMail || 'uns') + ' senden'; }
            return lp;
          };
          if (this.setup) lines.push({ id: this.setup.id, quantity: 1, properties: labelProps({ _kultb2b_label_line: 'setup', 'Firmenpräsent': 'Etikett-Service: Pauschale (Bearbeitung & Druck), einmal je Bestellung' }) });
          var sorts = this.labelSorts().map((it) => it.title).join(', ');
          lines.push({ id: this.perBag.id, quantity: this.labelBags(), properties: labelProps({ _kultb2b_label_line: 'bags', 'Firmenpräsent': 'Etikett-Service: Etikett je Kaffeetüte (' + this.bagsText(this.labelBags()) + ': ' + sorts + ')' }) });
        }
        return removeOld();
      }).then(() => fetch(this.addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines })
      }))
        .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
        .then((res) => {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
          return fetch('/cart.js').then((r) => r.json());
        })
        .then((cart) => this.syncShipAttribute(cart))
        .then((cart) => {
          if (this.dataset.cartUrl) { window.location.href = this.dataset.cartUrl; return; }
          document.dispatchEvent(new CustomEvent('kult:cart:add', { detail: { cart: cart, title: this.boxTitle } }));
        })
        .catch((err) => this.flashError('Das hat leider nicht geklappt: ' + err.message))
        .finally(() => { this.submitBtn.classList.remove('is-loading'); this.render(); });
    }
  }

  if (!customElements.get('kult-b2b-builder')) customElements.define('kult-b2b-builder', KultB2bBuilder);
})();
